var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1175 862.87",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8E8E8;}\n\t.st1{fill:none;stroke:#E8E8E8;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:#EC615B;}\n\t.st3{fill:#5222D0;}\n\t.st4{fill:#161616;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{opacity:0.73;fill:#FFFFFF;stroke:#161616;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:#FFFFFF;stroke:#161616;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{opacity:0.23;fill:#6D6C6C;}\n\t.st9{opacity:0.24;fill:#6D6C6C;}\n\t.st10{opacity:0.19;fill:#6D6C6C;}\n\t.st11{opacity:0.29;fill:#6D6C6C;}\n\t.st12{opacity:0.26;fill:#6D6C6C;}\n\t.st13{opacity:0.34;fill:#6D6C6C;}\n\t.st14{opacity:0.47;fill:#6D6C6C;}\n\t.st15{fill:#161616;stroke:#161616;stroke-width:2;stroke-miterlimit:10;}\n\t.st16{opacity:0.18;fill:#6D6C6C;}\n\t.st17{opacity:0.28;fill:#6D6C6C;}\n\t.st18{opacity:0.33;fill:#6D6C6C;}\n\t.st19{opacity:0.38;fill:#6D6C6C;}\n\t.st20{opacity:0.25;fill:#6D6C6C;}\n")), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1047.1,
    cy: 87.038,
    rx: 53,
    ry: 52.1,
    style: {
      fill: "#7437ec"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 1022.9,
    cy: 251.24,
    rx: 28.7,
    ry: 29.4,
    style: {
      fill: "#37ec74"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 156.84,
    cy: 150.74,
    rx: 62.1,
    ry: 60.9,
    style: {
      fill: "#37ec74"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 888.74,
    cy: 748.74,
    rx: 58.6,
    ry: 57.7,
    style: {
      fill: "#7437ec"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-205.56 -198.96)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m363.2 502.4c1.9 0 1.9-3 0-3s-2 3 0 3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m361.9 506.9c7.7 0 7.7-12 0-12s-7.7 12 0 12z",
    style: {
      fill: "#37ec74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m1117.8 321.4c7.7 0 7.7-12 0-12s-7.7 12 0 12z",
    style: {
      fill: "#37ec74"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m1093.5 716.6c7.7 0 7.7-12 0-12s-7.7 12 0 12z",
    style: {
      fill: "#37ec74"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m237.7 727.4c-4.6 4.4-0.5 11.2 5.1 11.8 3.8 0.4 12.8-4 12.8 2.3 0 3.1-0.8 6.3 0.9 9.1 1.4 2.3 3.9 3.4 6.6 3.3 4-0.1 7.7-4 10 0.8 1.3 2.8 1.5 5.3 4.7 6.7 2.8 1.3 5.3 0.5 7-2 2.2-3.2-3-6.2-5.2-3 0.7-1-1.7-6.5-2.5-7.5-1.1-1.5-2.7-2.6-4.6-2.9-2-0.4-4 0.2-5.9 0.8-3 0.9-5.4 1.6-5.3-2.4 0.2-4.1 0.6-8.6-3.4-11.2-1.8-1.2-4-1.4-6.1-1.3-1.3 0.1-2.5 0.3-3.7 0.6-0.9 0.2-8.3 1.1-6.2-0.9 2.8-2.6-1.4-6.8-4.2-4.2z",
    style: {
      fill: "#37ec74"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m268.8 724.1c0.6 3.4 1.3 6.9 1.9 10.3 0.2 1.3 1.7 2.2 2.9 2.2 3.8-0.1 5.9-2 9.1-3.6 5.3-2.7 3.7 2.2 4.5 5.7 0.6 2.5 2 4.4 4.5 5.3 4.7 1.6 8.7 1.5 12.8 4.9 3 2.4 7.2-1.8 4.2-4.2-3.3-2.7-6.9-4.8-11.1-5.6-1.1-0.2-2.4-0.2-3.5-0.8-1.6-0.9-1.2-1.4-1.2-3.3-0.1-1.6-0.1-3.2-0.7-4.8-1.2-2.8-4-4.2-7-4-4.4 0.3-7.3 4.6-11.6 4.6 1 0.7 1.9 1.5 2.9 2.2-0.6-3.4-1.3-6.9-1.9-10.3-0.7-4-6.5-2.4-5.8 1.4z",
    style: {
      fill: "#37ec74"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m610 313.8c1.8-2.4 3.8-2.8 6-1 1.2 1.5 1.8 3.1 1.8 5 0.1 1.8-0.7 3.5-0.8 5.3-0.1 1.6 0.1 3.1 1.4 4.1 2.8 2.1 6.6-0.5 8.3-2.8 0.8-1.1 1.5-3.2 2.6-3.9 4.4-2.9 4.1 1.3 4.9 3.1 0.6 1.5 1.4 2.6 2.8 3.3 4.9 2.4 8.9-2.4 11.2-6.1 1-1.6-1.6-3.1-2.6-1.5-1.5 2.3-5.3 8.5-8.8 2.9-0.6-1-0.5-2.5-1.1-3.6-0.8-1.4-1.9-2.6-3.6-2.8-2-0.2-3.7 1.1-5 2.5-1.8 1.9-6.6 10.9-6.9 3.2-0.1-4.6 1-10-4.3-12.3-3.6-1.6-7.7 0-9 3.7-0.4 1.9 2.5 2.7 3.1 0.9z",
    style: {
      fill: "#7437ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m611.3 301c3-2.8 8.5-2.2 10.8 1.4 1.4 2.2 0.4 5.1 1.9 7.2 0.9 1.3 2 1.7 3.6 1.4 1-0.2 1.5-0.7 2.4-1.2 3.2-2 6-2.8 9 0.4 1.3 1.4 3.4-0.7 2.1-2.1-2.4-2.6-5.9-3.8-9.3-2.8-1.8 0.6-4.5 3.3-5.5 1.3-0.7-1.3-0.3-3.3-0.9-4.7-2.8-6-11.3-7.4-16-3-1.7 1.3 0.5 3.4 1.9 2.1z",
    style: {
      fill: "#7437ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m1002 742.9c1 3.6 2.3 18.1 9.3 15.3 2.7-1.1 4.2-7.2 6.5-6.9 1.7 0.2 1.3 0.9 1.7 2.5 0.4 1.4 0.8 2.7 1.4 4 1 2.2 2.2 4.2 3.6 6.1 0.6 0.8 2.1 1.1 2.6 0 2.6-5.6 9.6-4.5 10.8 1.2 0.4 1.9 3.3 1.1 2.9-0.8-1.8-8.5-12.6-9.8-16.3-1.9h2.6c-1.6-2.2-3-4.4-4-7-0.7-1.9-0.6-5-1.7-6.7-1-1.6-2.8-1.9-4.5-1.4-2.6 0.9-3.1 3.3-4.7 5.2-0.6 0.8-2.7 2.8-3.9 2.1-0.6-0.4-1.1-3.6-1.4-4.5-0.7-2.7-1.5-5.4-2.2-8.1-0.3-1.7-3.2-0.9-2.7 0.9z",
    style: {
      fill: "#7437ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m1028.3 748.1c2.1-5 7.8-2.8 9.4 0.9 0.7 1.6 1.2 3.4 2.7 4.5 4.3 3.1 9-4 11.8 3.1 2.5 6.4 10.2 9.3 14.8 2.8 1.1-1.6-1.5-3.1-2.6-1.5-1.3 1.8-3.6 2.7-5.8 2-2.6-0.8-3-3.1-3.9-5.3-0.6-1.5-1.1-3.1-2.4-4.2s-2.8-1.3-4.4-1c-0.9 0.2-1.8 1-2.7 1.2-3.3 0.6-3.9-1.2-5.1-3.6-3.1-6.3-11.9-6.5-14.8 0.3-0.7 1.8 2.2 2.6 3 0.8z",
    style: {
      fill: "#7437ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m1325.2 404.3c-4.2-4.1-2.5-12.6 3.2-14.6 7.1-2.4 12.9 7 9.6 12.9-1 1.7 1.6 3.2 2.6 1.5 4.5-7.9-2.8-19.7-12.3-17.5-8.4 2-11.3 14-5.3 19.8 1.4 1.3 3.5-0.8 2.2-2.1z",
    style: {
      fill: "#7437ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m542.3 1003.1c-6-6.9-2.5-19 7.7-18.6 8.9 0.4 11.9 12.4 3.9 16.6-1.7 0.9-0.2 3.5 1.5 2.6 10.2-5.4 6.8-21-4.6-22.1-13.3-1.3-18.6 14.4-10.7 23.6 1.3 1.5 3.4-0.6 2.2-2.1z",
    style: {
      fill: "#7437ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m529.1 864.2c-3.4-2.7-10.4-9.8-1.2-11.9 1.8-0.4 3.5 0.4 5.3-0.3 3.6-1.4 4.8-5.3 4.7-8.9-0.1-2.4-0.9-4.7-1.4-7-0.6-2.7-1.8-5.8 2-5.9 0.7 0 1.4 0.3 2.2 0.3 3.5 0 6-2.4 7.2-5.5 0.7-1.8-2.2-2.6-2.9-0.8-2.4 6.6-10.3-1.2-11.8 6.4-1.1 5.9 6.6 18.1-3.7 18.7-4.1 0.2-7.7 0.1-8.8 5-1.1 5.1 2.8 8.9 6.4 11.8 1.3 1.4 3.5-0.7 2-1.9z",
    style: {
      fill: "#7437ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m551.3 850.2c-1.5-2.5-4-6.9-2.9-10 1.2-3.3 6.8-3 9.4-5.2 3.5-2.9 4.8-7.4 3.6-11.8-0.5-1.9-3.4-1.1-2.9 0.8 0.8 2.8 0.3 5.5-1.6 7.7-1.9 2.1-4 2-6.4 2.9-1.9 0.7-3.5 1.6-4.5 3.4-2.2 4.4 0.4 9.9 2.7 13.7 1 1.6 3.6 0.1 2.6-1.5z",
    style: {
      fill: "#7437ec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-205.56 -198.96)",
    style: {
      fill: "#808080"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#808080"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m308.6 410c-2.8 1.9-7.9 5.9-11.6 3.3-4.1-2.8 0.5-10.2 2-13.1 3.4-6.6 7.6-12.8 12.3-18.5 9.5-11.6 20.8-21.6 32.2-31.3 2.9-2.5-1.3-6.7-4.2-4.2-15.7 13.4-31.4 27.5-42.3 45.4-3.7 6.1-10.6 16.3-6.4 23.6 4.8 8.3 14.9 4.2 20.9 0.1 3.3-2.3 0.3-7.5-2.9-5.3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m365.8 331.1 27-21.9c3-2.4-1.3-6.7-4.2-4.2l-27 21.9c-3.1 2.4 1.2 6.6 4.2 4.2z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m417.1 297.3c4.6-2.4 21.3-12.2 24.3-4.3 2.6 6.8-3.8 16.7-7.9 21.7-2.4 3 1.8 7.2 4.2 4.2 6-7.3 14-20.8 8.2-30.4-6.6-10.8-24.1-0.5-31.9 3.6-3.4 1.8-0.3 7 3.1 5.2z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m333 381.4c13.6-15.5 28.8-29.6 45.4-41.9 3.1-2.3 0.1-7.5-3-5.2-17 12.6-32.6 26.9-46.6 42.9-2.6 2.8 1.6 7.1 4.2 4.2z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1058.4 898.1c1.5-11.2 16.7-6.4 22.9-3.5s12.1 6.5 17.6 10.5c12.1 8.9 22.4 20.4 30.5 33.1 8.7 13.6 15 28.6 19.4 44.2 2 7.1 14.4 49.7-3.3 45.1-3.7-1-5.3 4.8-1.6 5.8 5.8 1.5 11.4-1.2 14.6-6.2 3.8-6 2.8-13.6 1.7-20.2-2.6-16.3-6.8-32.5-13.3-47.7-11.8-28.1-31.7-53.6-59.1-67.9-7-3.6-15.2-7.6-23.3-5.9-6.6 1.3-11.4 6.2-12.2 12.8-0.4 3.8 5.6 3.7 6.1-0.1z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1126.5 954.5c10.3 15.8 15.4 34.1 14.8 53-0.1 3.9 5.9 3.9 6 0 0.7-19.9-4.7-39.4-15.6-56-2.1-3.3-7.3-0.3-5.2 3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1070.7 877.3c10.3 1.2 19.7 5.9 27 13.2 2.7 2.7 7-1.5 4.2-4.2-8.5-8.6-19.3-13.6-31.2-15-3.8-0.4-3.8 5.6 0 6z",
    style: {
      fill: "#666666"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m424.8 349.7v1.2c0 0.8 0 2-0.1 3.5-0.2 3.1-0.7 7.6-2.2 13.2-1.5 5.5-3.9 12.2-8.2 19.1-4.3 6.8-10.4 13.9-18.8 19.6-4.1 2.8-8.8 5.3-13.9 7.2-1.3 0.5-2.6 0.9-3.9 1.3s-2.7 0.8-4 1.1c-0.7 0.2-1.4 0.3-2.1 0.5-0.7 0.1-1.4 0.2-2.1 0.4-1.4 0.3-2.8 0.4-4.3 0.6-1.4 0.2-2.9 0.2-4.3 0.3-1.5 0-2.9 0.1-4.4 0-0.7 0-1.4-0.1-2.2-0.1-0.7 0-1.5-0.1-2.2-0.2-1.5-0.1-3-0.4-4.5-0.6-3-0.5-6-1.2-8.9-2.1s-5.8-2-8.7-3.3c-11.3-5.2-21.5-13.7-28.9-24.5-7.3-10.8-11.7-23.8-11.9-37.2 0-3.3 0.1-6.7 0.5-10 0.5-3.3 1.1-6.6 2-9.8 1-3.2 2.1-6.3 3.5-9.4 1.4-3 3-5.9 4.8-8.7 7.3-11.1 17.8-19.7 29.4-24.8 11.6-5.2 24.2-6.8 35.7-5.4 5.8 0.7 11.3 2 16.4 4s9.8 4.5 13.9 7.3c8.3 5.7 14.4 12.8 18.8 19.7 4.4 6.8 6.7 13.6 8.2 19.1 1.5 5.6 2 10.1 2.1 13.2 0.1 1.5 0.1 2.7 0.1 3.5 0.2 0.9 0.2 1.3 0.2 1.3zm-0.4 0v-1.2c0-0.8 0-2-0.2-3.5-0.2-3-0.7-7.5-2.4-13-0.8-2.7-1.9-5.7-3.4-8.8s-3.3-6.3-5.6-9.5c-4.6-6.4-10.9-12.8-19.1-17.8-4.1-2.5-8.6-4.7-13.4-6.5-4.8-1.7-10.1-2.9-15.5-3.5-1.4-0.2-2.7-0.2-4.1-0.3h-2.1-2.1c-0.7 0-1.4 0-2.1 0.1-0.7 0-1.4 0.1-2.1 0.1-1.4 0.1-2.8 0.3-4.2 0.5-2.8 0.4-5.7 1-8.5 1.8-1.4 0.4-2.8 0.9-4.2 1.3-0.7 0.2-1.4 0.5-2.1 0.8s-1.4 0.5-2.1 0.8c-11 4.6-21 12.6-28.2 22.9-1.8 2.6-3.4 5.3-4.8 8.1s-2.6 5.8-3.6 8.8-1.8 6.1-2.3 9.3-0.8 6.3-0.9 9.6c0 3.2 0.1 6.5 0.5 9.7 0.5 3.2 1.1 6.4 2 9.5s2.1 6.1 3.4 9c1.4 2.9 3 5.7 4.8 8.3 3.6 5.3 7.9 10 12.8 13.9s10.3 7 15.9 9.3c2.8 1.1 5.6 2.1 8.5 2.8 2.9 0.8 5.8 1.3 8.6 1.6 1.4 0.1 2.9 0.3 4.3 0.4 0.7 0 1.4 0.1 2.1 0.1h2.2c1.4 0 2.8-0.1 4.2-0.1 1.4-0.1 2.8-0.2 4.1-0.4 5.4-0.7 10.7-1.9 15.5-3.7s9.3-4 13.4-6.6c8.1-5.1 14.5-11.5 19.1-17.9 2.3-3.2 4.1-6.4 5.6-9.5s2.6-6 3.4-8.8c1.7-5.5 2.2-10 2.4-13 0.2-1.5 0.1-2.7 0.2-3.5-0.1-0.7 0-1.1 0-1.1z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1163.1 954.7s-0.1 1.4-0.2 3.9c0 0.6 0 1.3-0.1 2.1s-0.2 1.6-0.4 2.5-0.2 1.9-0.5 3c-0.2 1-0.5 2.1-0.8 3.3-1.3 4.6-3.1 10.2-6.8 15.9-0.9 1.4-1.9 2.8-3 4.3-0.5 0.8-1.1 1.4-1.7 2.1s-1.2 1.4-1.8 2.1c-0.3 0.4-0.6 0.7-1 1l-3.1 3.1c-1.5 1.3-3.2 2.5-4.9 3.8-6.9 4.8-15.6 8.2-25.2 9.2-1.2 0.2-2.4 0.1-3.6 0.2-0.6 0-1.2 0-1.8 0.1h-0.9-0.2-0.7c-2.4-0.2-4.8-0.2-7.3-0.8-5.1-0.7-9.9-2.4-14.7-4.5-1.2-0.6-2.3-1.2-3.5-1.8-0.6-0.3-1.1-0.6-1.7-1l-3.4-2.2c-0.5-0.4-1.1-0.8-1.6-1.2-1-0.8-2.1-1.6-3.1-2.4-4-3.5-7.6-7.5-10.7-11.9-0.7-1.1-1.4-2.3-2.1-3.5l-0.5-0.9c-0.2-0.3-0.3-0.6-0.5-0.9l-1.8-3.6c-0.3-0.6-0.5-1.3-0.8-1.9-0.5-1.3-1-2.5-1.4-3.8-1.7-5.2-2.6-10.7-2.8-16.3l0.1-4.1c0-0.7 0-1.3 0.1-2l0.6-4.2 0.1-1 0.2-1 1-4.1c1.6-5.3 3.9-10.4 6.9-15.1 3.1-4.6 6.8-8.7 10.9-12.2 1-0.9 2.2-1.6 3.2-2.5 0.5-0.4 1.1-0.8 1.6-1.2l1.7-1.1 1.7-1c0.6-0.3 1.1-0.7 1.7-1 1.2-0.6 2.4-1.2 3.6-1.7 4.9-2.1 9.9-3.7 14.9-4.3 2.5-0.5 5-0.5 7.5-0.6h0.8 0.2l0.9 0.1c0.6 0 1.2 0.1 1.8 0.1s1.2 0.1 1.8 0.1 1.2 0 1.8 0.2c1.2 0.2 2.4 0.4 3.6 0.6l1.8 0.3c0.6 0.1 1.1 0.3 1.7 0.4 1.1 0.3 2.3 0.6 3.4 0.9s2.2 0.8 3.2 1.2c4.3 1.6 8.1 3.8 11.6 6.1 1.7 1.2 3.3 2.5 4.8 3.8l2.1 2.1c0.4 0.3 0.7 0.7 1 1 0.4 0.3 0.7 0.7 1 1 0.6 0.7 1.2 1.4 1.8 2.1s1.2 1.4 1.7 2.1c1 1.5 2.1 2.9 3 4.3 3.6 5.7 5.5 11.3 6.7 15.9 0.3 1.2 0.5 2.3 0.8 3.3 0.2 1 0.3 2 0.5 3 0.1 0.9 0.3 1.8 0.4 2.5 0.1 0.8 0.1 1.5 0.1 2.1 0.3 2.7 0.3 4 0.3 4zm-0.4 0s-0.1-1.4-0.2-3.9c-0.1-0.6 0-1.3-0.2-2.1-0.1-0.8-0.3-1.6-0.4-2.5-0.2-0.9-0.3-1.9-0.5-2.9-0.3-1-0.6-2.1-0.9-3.2-0.2-0.6-0.3-1.2-0.5-1.7-0.2-0.6-0.5-1.2-0.7-1.8s-0.5-1.2-0.8-1.9c-0.3-0.6-0.5-1.3-0.9-1.9-0.7-1.3-1.3-2.6-2.1-3.9s-1.7-2.6-2.6-3.9c-3.8-5.3-9.1-10.5-15.9-14.7-3.4-2-7.1-3.9-11.1-5.2-1-0.3-2-0.7-3-1s-2.1-0.5-3.2-0.8c-0.5-0.1-1.1-0.3-1.6-0.4s-1.1-0.2-1.6-0.2c-1.1-0.2-2.2-0.3-3.3-0.5-0.5-0.1-1.1-0.1-1.7-0.1s-1.2 0-1.8-0.1c-0.6 0-1.2 0-1.8-0.1h-1.7c-2.3 0.2-4.6 0.1-7 0.6-1.2 0.2-2.3 0.3-3.5 0.6s-2.3 0.6-3.5 0.9c-1.2 0.2-2.3 0.7-3.5 1.1l-1.7 0.6c-0.6 0.2-1.2 0.4-1.7 0.7-1.1 0.5-2.2 1-3.4 1.6-0.6 0.2-1.1 0.6-1.6 0.9l-3.2 1.8c-0.5 0.3-1 0.7-1.5 1.1-1 0.7-2.1 1.5-3.1 2.2-3.9 3.2-7.4 7-10.4 11.2-2.9 4.3-5.3 9-7 14l-1.1 3.8-0.3 1-0.2 1-0.3 1.9-0.4 1.9c-0.1 0.6-0.1 1.3-0.2 2l-0.3 4c0 5.3 0.6 10.7 2 15.8 1.6 5.1 3.8 10 6.8 14.4 0.8 1.1 1.6 2.1 2.4 3.2 0.4 0.5 0.8 1.1 1.2 1.5l2.6 2.8c0.2 0.2 0.4 0.5 0.7 0.7l0.7 0.6c1 0.9 2 1.7 2.9 2.6 1 0.8 2.1 1.5 3.1 2.3 0.5 0.4 1 0.8 1.6 1.1l3.4 1.8c0.6 0.3 1.1 0.6 1.7 0.9 1.2 0.5 2.3 1 3.4 1.5 0.6 0.3 1.2 0.5 1.7 0.7l1.8 0.6c1.2 0.4 2.3 0.8 3.5 1 1.2 0.3 2.4 0.5 3.6 0.8 1.2 0.2 2.4 0.3 3.5 0.5 2.3 0.4 4.8 0.3 7.2 0.4h0.7c0.1 0-0.1 0 0 0l0.9-0.1c0.6 0 1.2-0.1 1.7-0.1 1.1-0.1 2.3-0.1 3.4-0.3 9-1.1 17.1-4.3 23.9-8.4 6.8-4.2 12-9.4 15.9-14.7 0.9-1.4 1.8-2.7 2.6-3.9 0.7-1.4 1.4-2.7 2.1-3.9 0.4-0.6 0.6-1.3 0.9-1.9s0.5-1.2 0.8-1.9c0.2-0.6 0.5-1.2 0.7-1.8s0.3-1.2 0.5-1.7c0.3-1.1 0.6-2.2 0.9-3.2s0.4-2 0.5-2.9 0.3-1.7 0.4-2.5 0.1-1.5 0.2-2.1c0.5-2.5 0.5-3.9 0.5-3.9z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1253.5 452.2s0 0.8-0.1 2.2c0 0.4 0 0.8-0.1 1.2s-0.1 0.9-0.2 1.5c-0.1 0.5-0.1 1.1-0.2 1.7s-0.3 1.2-0.4 1.9c-0.7 2.6-1.7 5.9-3.7 9.2s-4.8 6.9-8.8 9.7c-4 2.9-9.1 4.9-14.7 5.5-0.7 0.1-1.4 0.1-2.1 0.1h-2.2c-1.4-0.1-2.7-0.2-4.2-0.5-3-0.5-5.7-1.5-8.5-2.8-2.7-1.3-5.2-3.1-7.6-5-2.3-2-4.4-4.3-6.2-6.9-0.8-1.3-1.7-2.6-2.3-4.1-0.4-0.7-0.7-1.4-1-2.1s-0.6-1.5-0.9-2.2c-1-3-1.6-6.2-1.8-9.4 0-1.7-0.1-3.1 0.2-4.8 0.1-1.7 0.5-3.2 0.9-4.8 0.9-3.1 2.2-6.1 4-8.8s3.9-5.1 6.3-7.2c2.5-2 5.1-3.8 7.9-5s5.8-2.2 8.8-2.5c1.5-0.3 3-0.3 4.4-0.4h1.2l1 0.1c0.7 0.1 1.3 0.1 2 0.2s1.4 0.2 2.2 0.3c0.4 0.1 0.7 0.1 1.1 0.2l1 0.3c0.7 0.2 1.3 0.4 2 0.5 0.6 0.2 1.3 0.5 1.9 0.7 2.5 0.9 4.7 2.3 6.7 3.7 4 2.9 6.8 6.5 8.8 9.8 2 3.4 3 6.6 3.7 9.3 0.1 0.7 0.3 1.3 0.4 1.9s0.2 1.2 0.2 1.7c0.1 0.5 0.1 1 0.2 1.5 0.1 0.4 0 0.9 0.1 1.2-0.1 1.3 0 2.1 0 2.1zm-0.4 0s0-0.8-0.1-2.2c0-0.4 0-0.8-0.1-1.2s-0.2-0.9-0.2-1.4c-0.1-0.5-0.2-1.1-0.3-1.7-0.2-0.6-0.4-1.2-0.5-1.8-0.1-0.3-0.2-0.7-0.3-1s-0.3-0.7-0.4-1c-0.3-0.7-0.6-1.4-1-2.1s-0.8-1.4-1.2-2.2c-0.5-0.7-1-1.4-1.6-2.2-2.2-2.9-5.3-5.8-9.1-8-1.9-1.1-4-2.1-6.2-2.8-0.6-0.2-1.1-0.4-1.7-0.5s-1.2-0.3-1.8-0.4l-0.9-0.2c-0.3-0.1-0.6-0.1-0.9-0.1-0.6-0.1-1.2-0.2-1.8-0.2-0.6-0.1-1.3-0.1-2-0.1h-1.5c-0.1 0 0.1 0 0 0h-0.4c-1.3 0.1-2.6 0.1-3.9 0.3-2.6 0.3-5.2 1.1-7.7 2.1s-4.9 2.5-7.1 4.2c-2.2 1.8-4.1 3.9-5.9 6.2-1.6 2.4-3 5-4 7.7-0.4 1.4-0.9 2.8-1.1 4.2-0.4 1.4-0.4 3.1-0.6 4.5 0 3 0.2 6 1 8.9 0.9 2.9 2.1 5.7 3.8 8.2 0.9 1.2 1.8 2.4 2.8 3.5 0.5 0.5 1 1.1 1.6 1.6l1.7 1.4c2.3 1.8 4.9 3.2 7.5 4.2 2.6 0.9 5.4 1.6 8 1.8 1.2 0.2 2.7 0.1 4.1 0.2h0.5s-0.1 0 0 0h0.5l1-0.1c0.6-0.1 1.3-0.1 1.9-0.2 5-0.7 9.5-2.4 13.3-4.6 3.8-2.3 6.9-5.1 9.1-8 0.5-0.8 1.1-1.5 1.6-2.2 0.4-0.8 0.8-1.5 1.2-2.2s0.6-1.4 1-2.1c0.1-0.3 0.3-0.7 0.4-1s0.2-0.7 0.3-1c0.2-0.6 0.4-1.3 0.5-1.8 0.2-0.6 0.2-1.1 0.3-1.6s0.2-1 0.2-1.4c0.1-0.4 0.1-0.8 0.1-1.2-0.2-1.7-0.1-2.5-0.1-2.5z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1313.6 286s-0.1 1.3-0.2 3.7c0 0.6 0 1.3-0.1 2s-0.2 1.6-0.4 2.4c-0.2 0.9-0.2 1.8-0.4 2.8s-0.5 2.1-0.8 3.2c-1.2 4.4-3 9.8-6.5 15.3-0.8 1.4-1.9 2.7-2.8 4.1-0.5 0.7-1.1 1.4-1.7 2-0.6 0.7-1.2 1.4-1.8 2.1-1.2 1.4-2.6 2.6-4 3.9-1.5 1.2-3 2.5-4.7 3.6-6.6 4.6-15 7.9-24.2 8.9-1.1 0.2-2.3 0.1-3.5 0.2-0.6 0-1.2 0-1.8 0.1h-0.9-0.2-0.7c-2.3-0.2-4.6-0.2-7-0.8-4.9-0.7-9.5-2.3-14.1-4.4-1.1-0.6-2.2-1.1-3.3-1.7-0.6-0.3-1.1-0.6-1.6-1l-3.2-2c-0.5-0.4-1-0.8-1.5-1.1-1-0.8-2-1.5-3-2.3-3.9-3.4-7.3-7.2-10.3-11.5-0.7-1.1-1.4-2.2-2.1-3.3l-0.5-0.8-0.4-0.9-1.8-3.6c-0.3-0.6-0.5-1.2-0.7-1.8-0.5-1.2-1-2.4-1.4-3.7l-1.1-3.8-0.3-1-0.2-1-0.3-2c-0.2-1.3-0.5-2.6-0.5-3.9l-0.3-4 0.1-3.9c0-0.7 0-1.3 0.1-2l0.6-4 0.1-1 0.2-1 0.9-3.9c1.5-5.1 3.8-10 6.7-14.5 3-4.4 6.5-8.3 10.5-11.7 1-0.8 2.1-1.6 3.1-2.4 0.5-0.4 1-0.8 1.6-1.1l3.2-2c0.5-0.3 1.1-0.7 1.7-0.9 1.2-0.6 2.3-1.1 3.4-1.7 4.7-2 9.5-3.5 14.3-4.1 2.4-0.5 4.8-0.5 7.2-0.6h0.7 0.2 0.9c0.6 0 1.1 0.1 1.7 0.1s1.1 0.1 1.7 0.1 1.1 0 1.7 0.2c1.2 0.2 2.3 0.4 3.5 0.5 0.6 0.1 1.2 0.2 1.7 0.3 0.6 0.1 1.1 0.3 1.6 0.4 1.1 0.3 2.2 0.6 3.3 0.9s2.1 0.8 3.1 1.1c4.1 1.5 7.8 3.6 11.1 5.9 1.6 1.2 3.2 2.4 4.7 3.7 1.4 1.4 2.8 2.6 4 4 0.6 0.7 1.2 1.4 1.8 2.1s1.2 1.3 1.6 2c1 1.4 2 2.8 2.8 4.1 3.5 5.5 5.2 10.9 6.5 15.3 0.3 1.1 0.5 2.2 0.8 3.2 0.2 1 0.3 2 0.4 2.8 0.1 0.9 0.2 1.7 0.4 2.4 0.1 0.7 0.1 1.4 0.1 2 0.2 2.7 0.3 4 0.3 4zm-0.4 0s-0.1-1.3-0.2-3.7c-0.1-0.6 0-1.3-0.2-2-0.1-0.7-0.3-1.5-0.4-2.4-0.2-0.9-0.3-1.8-0.5-2.8-0.3-1-0.6-2-0.9-3.1-0.2-0.5-0.3-1.1-0.5-1.7s-0.4-1.1-0.7-1.7c-0.2-0.6-0.5-1.2-0.7-1.8s-0.5-1.2-0.8-1.8c-0.6-1.2-1.3-2.5-2-3.7-0.8-1.2-1.7-2.5-2.5-3.8-3.7-5-8.8-10.1-15.2-14-3.3-1.9-6.8-3.8-10.6-5-1-0.3-1.9-0.7-2.9-1-1-0.2-2-0.5-3-0.7-0.5-0.1-1-0.3-1.5-0.4s-1-0.2-1.5-0.2c-1-0.1-2.1-0.3-3.1-0.4-0.5-0.1-1.1-0.1-1.6-0.1-0.6 0-1.1 0-1.7-0.1-0.6 0-1.1 0-1.7-0.1h-1.6c-2.2 0.2-4.5 0.1-6.7 0.5-4.5 0.5-8.9 2-13.3 3.7-1.1 0.5-2.1 1-3.2 1.5-0.6 0.2-1.1 0.5-1.6 0.8l-1.5 0.9-1.6 0.9c-0.5 0.3-1 0.7-1.5 1-1 0.7-2 1.4-2.9 2.1-3.8 3.1-7.1 6.7-10 10.7-2.8 4.1-5 8.6-6.7 13.4-1.6 4.8-2.4 9.7-2.7 15 0 5 0.6 10.2 1.9 15.1 1.5 4.9 3.7 9.6 6.5 13.8 0.7 1 1.5 2 2.3 3 0.7 1 1.6 1.9 2.5 2.9l1.3 1.4c0.2 0.2 0.4 0.5 0.6 0.7l0.7 0.6c0.9 0.8 1.9 1.6 2.8 2.5 1 0.8 2 1.4 3 2.2 0.5 0.3 1 0.7 1.5 1l3.2 1.8c0.5 0.3 1 0.6 1.6 0.8 1.1 0.5 2.2 1 3.3 1.5 0.5 0.3 1.1 0.5 1.7 0.6l1.7 0.6c1.1 0.4 2.2 0.8 3.4 1 1.1 0.3 2.3 0.5 3.4 0.8 1.1 0.2 2.3 0.3 3.4 0.5 2.2 0.4 4.6 0.3 6.9 0.4h0.7c0.1 0-0.1 0 0 0l0.8-0.1c0.6 0 1.1-0.1 1.7-0.1 1.1-0.1 2.2-0.1 3.3-0.3 8.6-1.1 16.4-4.1 22.9-8.1s11.6-9 15.2-14.1c0.9-1.3 1.7-2.6 2.5-3.8 0.7-1.3 1.3-2.5 2-3.8 0.3-0.6 0.6-1.2 0.8-1.8s0.5-1.2 0.7-1.8 0.5-1.2 0.7-1.7c0.2-0.6 0.3-1.1 0.5-1.7 0.3-1.1 0.6-2.1 0.9-3.1s0.4-1.9 0.5-2.8 0.3-1.7 0.4-2.4 0.1-1.4 0.2-2c-0.1-2.3 0-3.6 0-3.6z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#808080"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m561.5 470.8c-0.9-0.6-0.7-2.1-0.3-2.9 0.7-1.4 2.9-1.8 4.3-1.8 2.8-0.1 5.6 1.2 8.2 1.9 3.6 1.1 7.4 1.7 11.1 0.5 6.6-2.3 9.1-9.2 11.5-15.2 1.4-3.5 4.5-9.7 9.1-9.5 3.8 0.2 6.2 4.8 10.4 4.9 7.2 0.3 12-7.3 14.5-13 1.5-3.5-3.6-6.6-5.2-3-2.1 4.8-6.2 12.7-12.1 8.4-3.2-2.3-6.1-4.3-10.3-3.1-8.9 2.4-10.9 12-14.5 19.1-3.1 6-7.4 6.7-13.7 4.9-4.4-1.3-9.1-2.8-13.7-1.1-6.2 2.4-8.4 11.3-2.3 15.1 3.3 2 6.3-3.1 3-5.2z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m607.2 470.4c-0.6-3.7 2.5-7.6 6.2-8.1 3.3-0.5 5.8 2.3 8.9 2.9 5.7 1 10.1-3.7 12.3-8.3 1.4-2.9 2.2-6.5 4.7-8.7 2.2-2 5.4-2.4 8.2-2.9 5.2-0.9 10.2-1.6 13.9-5.8 2.5-2.9-1.7-7.1-4.2-4.2-4.3 4.9-12.1 3.5-17.8 5.9-7.2 3.1-7.3 9.8-11.6 15.4-3.7 4.8-7.5 0.3-11.9-0.2-2.6-0.3-5.3 0.3-7.6 1.5-5.2 2.9-7.8 8.3-6.8 14.1 0.6 3.8 6.4 2.2 5.7-1.6z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m620.2 765.3c-3.9-5.3 0-13.6 7.1-11.5 6.9 2 6.4 11.5-0.3 13.5-3.7 1.1-2.1 6.9 1.6 5.8 11.8-3.6 13.2-20.5 1.1-24.8-11.9-4.3-22.2 9.9-14.7 20 2.2 3.1 7.5 0.1 5.2-3z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1203.5 632.8c-0.5-1.8 0.8-2.3 3.8-1.4 1.4 0.5 2.7 1 4 1.6 1.4 0.6 2.8 1.1 4.3 1.4 2.8 0.5 5.6-0.1 7.9-1.9 4.9-3.9 4.2-10.4 7.2-15.2 3.2-5.2 5.5-1.5 7.9 1.5 1.3 1.7 2.8 3.1 5 3.6 2.3 0.5 4.6-0.3 6.4-1.8 1.2-1 2.2-2.3 3-3.6 0.1-0.2 4.5-6.6 4.6-4.9 0.2 3.8 6.2 3.9 6 0-0.1-3.6-2.8-6.1-6.4-6.2-4.2-0.1-6.5 3.2-8.4 6.4-1.8 2.9-3.8 5.4-6.3 1.8-1-1.4-1.8-2.8-3.2-3.9-3.1-2.5-7-2.3-10.1 0-3.5 2.5-5 6.6-6.1 10.5-0.6 2.3-1.2 5.3-3 7-2.8 2.5-6.8-0.3-9.6-1.4-3.9-1.5-8.8-1.9-11.6 1.9-2.1 2.9-2.1 6.5 0.4 9 2.7 2.6 6.9-1.7 4.2-4.4z",
    style: {
      fill: "#666666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1251.9 638.9c-1.1-4.3 4.8-5 7.5-4.5 2.3 0.4 4.4 1.3 6.7 1.9 3.6 1 7.6 1.6 11.2 0.3 2.8-1 4.8-3 6.3-5.5 1.8-3 2.4-7.2 5.5-9.2 3.2-2.1 0.2-7.3-3-5.2-3.7 2.4-5 5.9-6.8 9.7-3.5 7.1-9.6 4.6-15.7 2.9-4.6-1.3-9.5-1.8-13.6 1.1-3.4 2.4-4.9 6.2-3.8 10.2 0.9 3.6 6.7 2 5.7-1.7z",
    style: {
      fill: "#666666"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m268.94 479.33c-0.33282-0.0885-0.6293-0.0758-0.9043 0.0117-3.4 1.1 0.70116 13.8-6.2988 20.1-3.8 3.4-9.1012 3.4992-12.701 3.1992-15.3-15.9-20.999-18.3-23.299-16.9-4.2 2.7 5.8996 18.302 2.0996 38.102-1.9 9.5-6.0004 15.4-15.9 28.6-22.9 30.5-33.901 43-43.301 56-7.5 10.3-17.9 26.4-27.5 48.6-3.1 3.8-7.8992 8.3-13.699 8.5-13.6 0.3-17-23-37-35.9-15.4-10-37.3-11.599-53.9-4.1992-31.6 13.9-37.8 56.6-34.9 58.1 2.8 1.5 15.801-33.9 43.301-38.1 9.5-1.4 17.7 1.2996 20.1 2.0996 14.2 5.1 18.001 15.3 30.701 26.4 6.5 5.7 16.799 12.9 32.799 18-1.6 3.8-3.0992 8.7988-3.1992 14.799-0.1 20 16.599 32.901 19.199 34.801 1.3 3 3.3012 8.3008 3.2012 15.301-0.1 8.7-3.4016 15.2-5.1016 18.1 5.2 7.5 10.2 12.999 13.9 16.699 8.7 8.5 12.1 9.1008 13.4 9.3008 8.2 0.80001 14.799-7.1008 16.199-8.8008-2.2-1-13.1-6.5-17.6-19.5-4.4-12.7 0.60039-23.7 1.9004-26.4 1.4-3 2.9992-5.4 4.1992-7 5.4 3.1 12.101 8.1012 15.301 16.201 4.4 11.1-1.6008 18.5 3.6992 25.5 5.6 7.3 18.101 7.2996 25.801 5.0996 8.3-2.3 16.9-8.6992 15.9-12.699-1.1-4.5-13.7-1.1-20.1-8.5-5.7-6.5-3.0016-17.4-1.1016-25.4 6.2-25.2 20.702-31.401 21.102-49.701 0.2-8.4-2.7008-15.4-5.3008-20.1 17.7-36.4 37.4-52.399 52.9-60.299 9.2-4.7 24.4-8.6008 42.4-22.301 8.2-6.2 14.299-11.8 21.299-18.5 8.5-8.1 27-25.799 24.6-29.199-2-2.7-16.598 4.8-20.898 7-20.6 10.6-23.101 18.699-36.701 21.799-3.135 0.70982-6.5731 1.042-9.9473 1.0586 7.672-6.8642 12.864-12.594 16.447-16.758 1.6-2 5.7008-6.9004 8.3008-14.4 1-2.7 3.7004-10.9 1.4004-12.5-3-2.1-11.6 8.6004-27.5 21.4-6.0981 4.9095-11.487 8.7072-16.223 11.918 2.183-6.3258 13.475-13.533 13.723-26.719 0.1-2.5-0.30118-5.5-13.701-28.5-10.675-18.2-14.766-23.691-17.096-24.311z",
    style: {
      fill: "#666666",
      strokeWidth: 2,
      stroke: "#161616"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-205.56 -198.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m466 724.2c0.1 0.1 0.1 0.2 0.1 0.3v0c0.1-0.3-0.1 0.1 0 0l-0.1 0.1c-0.1 0.1 0.1 0 0 0h-0.3s-0.3-0.1-0.1 0l-0.1-0.1c0.1 0.1 0 0.1 0 0v-0.3c0-0.1 0.1-0.2 0-0.1 0.1-0.1 0.1-0.2 0.2-0.2-0.2 0.1 0 0 0.1 0-0.4 0 0.2 0 0 0s0.3 0.1 0.1 0 0.3 0.2 0 0c-0.7-0.4-1.7-0.1-2.1 0.5-0.4 0.7-0.1 1.6 0.5 2.1 1 0.7 2.5 0.5 3.3-0.4 1-1 1-2.6 0.1-3.6s-2.3-1.2-3.4-0.5c-1.2 0.8-1.5 2.3-0.9 3.6 0.4 0.7 1.4 0.9 2.1 0.5 0.7-0.3 0.8-1.2 0.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m487 715.9c-0.2-0.3 0.1 0.2 0 0.4 0 0.1-0.1 0.2-0.1 0.3-0.3 0.3-0.9 0.4-1.2 0-0.4-0.5 0-1.1 0.4-1.2-0.2 0.1 0 0 0.1 0 0.2 0 0.4 0.1 0.5 0.2-0.6-0.6-1.6-0.6-2.1 0-0.6 0.6-0.6 1.5 0 2.1 0.7 0.8 2 0.9 2.9 0.3 1.1-0.7 1.3-2.2 0.6-3.2s-2.1-1.3-3.1-0.5c-0.9 0.7-1.2 2.1-0.6 3.1 0.5 0.7 1.3 1 2.1 0.5 0.6-0.4 1-1.4 0.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m481.3 726.6c0.8 1.9 2 8.5-1.6 8.6-1 0-1 1.5 0 1.5 5.1-0.1 4.2-7.9 2.9-10.8-0.4-1-1.7-0.2-1.3 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m481.8 727.1c0.8 2.2 2.3 4.7 4.6 5.6 1.9 0.7 4.1-0.3 4.2-2.4 0.1-1-1.4-1-1.5 0-0.1 2.4-3.1 0.6-3.9-0.2-0.9-1-1.6-2.1-2-3.4-0.3-0.9-1.7-0.5-1.4 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m462.6 727.9c1.8-0.4 3.5-0.3 5.1 0.4 0.9 0.4 1.3-1.1 0.4-1.4-1.9-0.8-3.9-0.9-5.9-0.4-0.9 0.2-0.5 1.6 0.4 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m489.3 713.4c-1 1.7-1.6 3.5-1.8 5.5-0.1 1 1.4 1 1.5 0 0.2-1.7 0.7-3.3 1.6-4.8 0.5-0.8-0.8-1.5-1.3-0.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m213.44 555.14c-12.8-11.5-16-26.3-16.6-29.3-4.9-24.9 10-44.1 13.1-47.9 16.6-20.4 49.3-32.3 75.1-18.8 20.3 10.7 26.3 32.1 27.8 38.2 4.5 19.1 0.2 42.3-16 57.7-23.8 22.7-62.8 18.7-83.4 0.1z",
    style: {
      fillOpacity: 0.46643,
      fill: "#ffffff"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "leg_r",
    transform: "translate(-205.56 -198.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m794.5 596.9c-13.3 11.4-31 28.8-47.6 53.2-12 17.7-32.4 48.5-39.5 92.8-10.3 64 13.8 114.6 21.8 129.9 29.1 55.7 74.4 81.7 91.2 90.4-3.7 6-8.9 15.4-13.7 27.4-1.1 2.9-22.8 58.4-8.1 68.6 11.1 7.6 37.8-13.6 41.9-16.9 24.4-19.5 35.8-45.7 48.4-75.8 5.3-12.8 9-23.5 11.3-30.7-13.9-9.7-34.5-26.4-52.4-52.4-11.2-16.2-49.4-71.6-33.1-122.6 7.5-23.4 18-19.8 46.8-67 21.1-34.7 33-54.1 26.6-70.2-8.6-21.8-47.6-31-93.6-26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m753.1 653.9c17.3-0.2 33.3-9.9 41.4-25.2 0.7-1.3-1.3-2.4-1.9-1.1-7.7 14.6-22.9 23.9-39.4 24.1-1.6 0-1.6 2.2-0.1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m796.8 947.9c22.9-10.6 42.3-27.6 55.7-49 0.8-1.2-1.2-2.4-1.9-1.1-13.3 21.1-32.3 37.8-54.9 48.2-1.3 0.6-0.2 2.5 1.1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m828.5 928.8c2 7.7 9.8 0.5 12.6-2.2 7.1-6.6 14.7-13 18.6-22.2 0.6-1.3-1.4-2.5-1.9-1.1-2.4 5.6-6.1 10.1-10.4 14.3l-5.7 5.4c-0.9 0.9-9.6 10-10.9 5.1-0.5-1.3-2.7-0.7-2.3 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m793.1 742.4c-10.3 19.5-14.5 41.5-12 63.4 0.2 1.4 2.4 1.4 2.3 0-2.5-21.5 1.5-43.1 11.6-62.2 0.7-1.3-1.3-2.5-1.9-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m783.2 818.4c-1.4-2.4-2.7-5.1-2.2-8 0.4-2.5 2.7-4.7 5.4-4.4 5.9 0.8 3 14.8-3.7 11.4-1.3-0.6-2.4 1.3-1.1 1.9 3.7 1.9 7.8-0.1 9.4-3.8 1.4-3.3 1.3-8.8-2-10.9-2.8-1.9-6.7-0.5-8.7 1.9-3.1 3.8-1.2 9.2 1 13 0.7 1.3 2.6 0.2 1.9-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m790.2 828.4c13.2 28.4 30.9 54.4 52.4 77.1 1 1.1 2.6-0.5 1.6-1.6-21.4-22.6-38.9-48.5-52.1-76.7-0.6-1.2-2.5-0.1-1.9 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m713.8 830.2c3.9-5.9 11.4-8.1 18.1-6 6.8 2.1 11.9 8 14.6 14.4 3.1 7.2 3.8 15.5 1.7 23.1-2.2 7.8-9 15.4-17.7 11.8-1.3-0.6-1.9 1.6-0.6 2.2 7.8 3.2 15.3-1.7 18.8-8.7 4.4-8.9 3.9-20.3-0.1-29.3-3.3-7.5-9.7-14.4-18-16-7.2-1.4-14.7 1.4-18.7 7.5-0.9 1.1 1.1 2.3 1.9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m718.2 842c1.1-6.2 8.9-6.3 13.4-4.1 3.5 1.7 6.4 4.8 8.1 8.3 1.9 3.9 2.5 8.6 1 12.8-2.2 6.1-7.9 7.3-13.8 7-1.4-0.1-1.4 2.2 0 2.3 6.4 0.4 12.6-1 15.4-7.3 2.4-5.4 1.5-12-1.4-17-2.8-4.9-7.8-8.9-13.6-9.5-4.9-0.5-10.4 1.7-11.3 7-0.2 1.3 2 1.9 2.2 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m754 909c14.3-6.9 26.8-16.6 37.1-28.6 0.9-1.1-0.6-2.7-1.6-1.6-10.2 11.9-22.6 21.4-36.7 28.3-1.2 0.6-0.1 2.6 1.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m771.4 898.3c1.7 2.1 3.9 6.5 6.7 7.4 2.2 0.7 4-1 5.6-2.2 5.3-3.7 10.2-7.7 13.6-13.3 0.8-1.2-1.2-2.4-1.9-1.1-2.7 4.4-6.3 7.7-10.3 10.7-1.7 1.3-3.5 3.1-5.7 2.9-2.6-0.2-4.6-4-6.3-6-1-1.1-2.6 0.5-1.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m828.8 891c-6.6 12.5-16.2 23-28.1 30.6-0.7 0.4-0.8 1.5 0 1.9 4.6 2.5 8.5 5.6 11.8 9.6 0.9 1.1 2.5-0.5 1.6-1.6-3.5-4.1-7.5-7.4-12.3-9.9v1.9c12.3-7.8 22.2-18.5 29-31.4 0.7-1.2-1.3-2.4-2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m717.7 707.4c10.1-1.3 20.2-1.1 30.2 0.9 9.4 1.9 19.6 4.7 25.8 12.6 0.9 1.1 2.5-0.5 1.6-1.6-6-7.7-15.8-10.7-25-12.7-10.7-2.4-21.7-2.8-32.6-1.4-1.4 0.2-1.4 2.4 0 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m709.6 734.7c17.1 0.5 33.5 5.1 48.4 13.5 1.3 0.7 2.4-1.2 1.1-1.9-15.2-8.6-32.1-13.3-49.5-13.9-1.4 0-1.4 2.3 0 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m773.2 720.6c-5.4 8.1-10.1 16.6-14.2 25.4-0.6 1.3 1.3 2.4 1.9 1.1 4.1-8.8 8.8-17.3 14.2-25.4 0.9-1.2-1.1-2.3-1.9-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m714.3 716.9c10.6-0.8 21 0.4 31.1 3.6 1.4 0.4 2-1.7 0.6-2.2-10.3-3.2-20.9-4.4-31.7-3.7-1.4 0.2-1.4 2.4 0 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m749.6 709.8c-1.8 2.5-2.9 5.3-3.5 8.3-0.2 1.4 1.9 2 2.2 0.6 0.5-2.9 1.6-5.4 3.2-7.8 0.9-1.2-1.1-2.3-1.9-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m749 716c7.5 2.3 14.3 6.1 20.2 11.3 1.1 0.9 2.7-0.6 1.6-1.6-6.2-5.4-13.3-9.4-21.2-11.9-1.4-0.4-2 1.8-0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m723.7 738.8c-5.6 11.3-8.8 23.4-9.4 36-0.1 1.4 2.2 1.4 2.3 0 0.6-12.2 3.7-23.9 9.1-34.9 0.6-1.3-1.3-2.4-2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m713.8 785.9c-0.8-2.1-1.8-4.6-1.1-6.9 0.6-2 3.1-3.9 4.9-2 1.6 1.6 2.3 4.7 1.1 6.7-1 1.7-3.2 2.3-4.8 1.1-1.2-0.8-2.3 1.1-1.1 1.9 2.4 1.7 5.8 0.9 7.5-1.4 2.1-2.8 1.3-6.9-0.7-9.5-2-2.5-5.2-2.5-7.4-0.3-3.1 3-1.9 7.4-0.6 11 0.5 1.3 2.7 0.7 2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m808.7 636.7c-10 13.9-20.8 27.2-32.2 40-1 1.1 0.6 2.7 1.6 1.6 11.5-12.9 22.4-26.4 32.5-40.4 0.9-1.3-1-2.4-1.9-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m776.7 678.8c4.3 4.2 9.6 6.6 15.5 7.1 1.4 0.1 1.4-2.1 0-2.3-5.3-0.5-10.1-2.8-13.9-6.5-1-0.9-2.6 0.7-1.6 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m784 669.6c3.8 3.7 8.3 6.4 13.4 8.1 1.4 0.5 2-1.7 0.6-2.2-4.7-1.6-8.8-4.1-12.4-7.5-1.1-1-2.7 0.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m796 676.2c-1.3 3.1-3.3 5.7-5.9 7.8-1.1 0.9 0.5 2.5 1.6 1.6 2.7-2.2 4.9-5 6.3-8.2 0.5-1.3-1.5-2.5-2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m796 655.6c3.6 3.8 8.2 6.2 13.4 7 1.4 0.2 2-2 0.6-2.2-4.8-0.7-9-2.9-12.4-6.4-1.1-1.1-2.7 0.5-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m801.5 648c3.1 3.1 6.9 5.3 11.2 6.3 1.4 0.3 2-1.8 0.6-2.2-3.9-0.9-7.4-2.8-10.2-5.7-1-1-2.6 0.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m811.9 653.3c0.1 2.8-1 5.3-3.2 7.2-1.1 0.9 0.5 2.5 1.6 1.6 2.6-2.2 4-5.4 3.8-8.8 0-1.5-2.2-1.5-2.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m783.2 745.4c-7.7 15.8-11.8 32.7-12.4 50.2 0 1.4 2.2 1.4 2.3 0 0.5-17.1 4.6-33.7 12.1-49.1 0.6-1.3-1.3-2.4-2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m799.1 713.9c9.9 7.4 18 16.6 24.2 27.3 0.7 1.3 2.7 0.1 1.9-1.1-6.4-11-14.8-20.5-25.1-28.1-1-0.9-2.1 1-1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m811.9 714.2c7.2 5.7 13.3 12.5 18.2 20.2 0.8 1.2 2.7 0.1 1.9-1.1-5-7.9-11.2-14.9-18.5-20.7-1.1-0.9-2.7 0.7-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m889.4 929.2c-11.8 12.4-7.8 30.2-12 45.4-2.6 9.5-7.5 18.4-11.6 27.3-4 8.8-8 17.5-12.1 26.3-0.6 1.3 1.3 2.5 1.9 1.1 7.4-16.2 15.9-32.2 22.1-48.9 5.9-15.9 0.7-36.6 13.1-49.6 1.2-1-0.4-2.6-1.4-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m820 964.5c7.2-4.5 14.8-7.7 23.1-9.5 1.4-0.3 0.8-2.5-0.6-2.2-8.5 1.8-16.4 5.1-23.7 9.7-1.1 0.8 0 2.8 1.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m873 917.9c-3.4 7.2-8 13.5-13.9 18.9-0.7 0.6-0.3 1.6 0.5 1.9 3 1 7.7 4.1 10.6 1.6 2.3-2 4.2-5.1 6.1-7.5 2.3-2.8 4.6-5.7 7-8.5 0.9-1.1-0.7-2.7-1.6-1.6-3.2 3.9-6.4 7.9-9.7 11.8-1.3 1.6-2.6 4.2-4.9 4.4-1.8 0.1-5.2-1.8-6.9-2.4 0.2 0.6 0.3 1.3 0.5 1.9 6-5.5 10.7-12 14.2-19.3 0.6-1.4-1.3-2.5-1.9-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m802 1007.9c6.4-4.7 16.7-3.7 23.5-0.2 1.3 0.7 2.4-1.3 1.1-1.9-7.5-3.8-18.7-5-25.8 0.2-1.1 0.8 0 2.8 1.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m797.8 1023.1c8-5.2 17.3-6.6 26.4-3.8 1.4 0.4 2-1.8 0.6-2.2-9.7-2.9-19.7-1.4-28.1 4.1-1.2 0.8-0.1 2.7 1.1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m825.4 1007.3c0.8 3.8-0.3 7.6-2.9 10.4-1 1.1 0.6 2.7 1.6 1.6 3.2-3.5 4.4-8 3.5-12.6-0.3-1.4-2.5-0.8-2.2 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m848 704c-10.3 4.5-46.7 21.8-63.5 62-14.2 33.9-6.3 64.5-0.5 87 13.2 51.2 44.7 84.5 62.5 100.5-0.5 5.5-1.8 13.8-6 23-8.1 17.7-19.6 22.6-28.5 35.5-5.9 8.7-12.1 23-10.5 47 2.9 0.3 7.1 0.4 12-0.5 7.4-1.3 18.9-5.4 36.5-25.5 11.6-13.3 19.1-25.9 25-37 7.6-14.3 17.1-34.8 25-61-29.2-22.6-47.8-45.7-59-62-15.1-22-20.7-37.2-22.5-42.5-4-11.8-11-32.8-6.5-58.5 1.6-8.9 2.5-14.1 6-20.5 9-16.4 23.5-19.7 28.5-36 1.5-4.8 1.6-9 1.5-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m817.9 745.1c-6.5 15-14.6 39.6-13.8 70.1 1.8 63.6 41.1 105.6 52 116.5 3.4 10.7 6.9 27.2 4.4 47-6 46.4-41 73.2-48.9 78.9 6.9-2.2 18-6.5 29.4-15 22-16.3 31.9-38.1 43.8-65.1 4.3-9.6 10-23.9 15-42-29.7-23-48.2-46.9-58.9-63.3-11.3-17.2-21.9-33.7-26.9-58.2-5.9-30-0.3-55.2 3.9-68.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "leg_l",
    transform: "translate(-205.56 -198.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m990.9 644.4c8.3 18 5 38.9 2.4 55-3.6 22.6-11.7 39.9-17.7 50.4-2.6 12.8-5.1 34.4 1.4 59.2 7.8 30 24.6 48.7 40.2 66 13.3 14.8 36.3 36.8 71.5 55.1-2 7.4-5.2 18.6-9.5 32.2-18.3 56.8-29.9 67.9-34.1 71.6-11.5 10.1-32.5 21.7-41.6 15-7.4-5.4-9.3-24.5 16.5-86.1-10.8-3.9-25.9-10-42.9-19.1-17.6-9.3-66.1-35.2-96.7-77.6-46.3-64.3-34.6-143.5-30.6-165.4-7.1-3.3-19.9-10.5-24.4-23.9-8.2-24.2 16.1-52.1 35.8-64.1 42.5-26.1 111.7-7.4 129.7 31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m827.6 645c-6 9.1-6.6 20.7-2.3 30.7 2.1 4.9 5.3 9.3 9.2 13 1.9 1.8 3.9 3.5 6.1 5 0.9 0.6 8.3 4.4 6.9 5.8 0.6-0.1 1.2-0.2 1.8-0.2-12.9-9.5-22.9-23.7-22.6-40.2 0-1.6-2.7-2.1-2.9-0.4-2.5 14.2 3.3 28.4 15 36.8l1.2-2.7c-14-4.3-17.1-19.8-13.5-32.4-1-0.1-2-0.3-2.9-0.4 1 13.2 2.6 27.2 13.1 36.5 1.4 1.3 3.5-0.8 2.1-2.1-11.6-11-18.5-28.2-8.8-42.8-0.9-0.1-1.8-0.2-2.7-0.4 0.4 2.3 0.5 4.5 0.1 6.8h2.9c-1.9-6.4-1.1-12.6 2.4-18.3-0.9-0.1-1.8-0.2-2.7-0.4 1.9 10.7-2.1 21.4-0.6 32.1 0.5 3.6 1.5 7.3 3.5 10.5 1 1.6 2.2 3 3.6 4.2 1.5 1.3 4.9 2.5 5.2 4.7l1.8-1.8c-2.1-0.3-4.3-0.6-6.4-0.9-1-0.1-2.3 0.7-1.8 1.8 1.7 4.3 4.4 7.3 8.6 9.3v-2.6h-3.1c-0.4 0.9-0.7 1.7-1.1 2.6 1.2 0.6 2.4 1.2 3.5 1.8 0.4-0.9 0.7-1.7 1.1-2.6-2.3 0.1-4.8-5-5.7-6.7-1.3-2.4-2.3-5-3.1-7.7-1.5-5.4-1.8-10.9-1-16.4-0.9 0.1-1.8 0.2-2.7 0.4 3.5 6.3 4.6 13.2 3.1 20.3 0.7-0.3 1.5-0.6 2.2-0.9-0.5-0.9-1-1.8-1.6-2.7-0.8 0.4-1.5 0.9-2.3 1.3 1.7 1 3.3 2 5 2.9 1.7 1 3.2-1.6 1.5-2.6s-3.3-2-5-2.9c-0.9-0.5-2.4 0.1-2.3 1.3 0.3 2.4 1.1 3.9 3.1 5.3 0.8 0.6 2 0 2.2-0.9 1.6-7.9 0.5-15.6-3.4-22.6-0.6-1-2.5-1-2.7 0.4-1.1 7.4-0.5 14.8 2.2 21.8 1.6 4.1 4.9 13 10.4 12.9 1.4 0 1.9-1.6 1.1-2.6-1.6-1.9-3.2-2.6-5.7-2.7-1.3-0.1-2 1.7-1.1 2.6 2 1.9 4.5 2.2 6.8 0.5 0.8-0.6 1.1-2.1 0-2.6-3.5-1.6-5.8-3.9-7.2-7.5l-1.8 1.8c2.1 0.3 4.3 0.6 6.4 0.9 1.2 0.2 2-0.6 1.8-1.8-0.5-3.5-4.2-4.3-6.5-6.4-3.8-3.5-5.4-8.9-5.9-13.9-0.9-10.5 2.6-20.7 0.7-31.1-0.2-1.3-2.1-1.4-2.7-0.4-3.9 6.3-4.9 13.5-2.7 20.6 0.4 1.3 2.7 1.6 2.9 0 0.4-2.9 0.4-5.5-0.1-8.4-0.2-1.4-2.1-1.3-2.7-0.4-10.4 15.7-3.3 34.5 9.3 46.4l2.1-2.1c-9.9-8.7-11.2-21.9-12.2-34.3-0.1-1.6-2.5-2.1-2.9-0.4-4.1 14.3 0.1 31.3 15.6 36.1 1.7 0.5 2.5-1.8 1.2-2.7-10.5-7.6-15.8-20.6-13.6-33.4-1-0.1-2-0.3-2.9-0.4-0.3 17.6 10.4 32.7 24.1 42.8 0.5 0.4 1.4 0.2 1.8-0.2 2.2-2.2 1.4-4.7-0.9-6.5-4.8-3.7-10-6-14.2-10.6-9.4-10.4-12.3-25.8-4.3-37.9 0.7-2.1-1.9-3.6-3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m963.7 667c2.2 11.5-4 22.8-8.5 33-3.8 8.7-7.7 17.4-11.1 26.3-6.4 17-10.3 34.6-9.8 52.9 0.9 33.2 14.8 65.9 38.7 89.2 15.7 15.2 34.6 26.4 53.5 37.1 1.3 0.7 2.4-1.2 1.1-1.9-16.7-9.5-33.4-19.2-47.9-32-13.4-11.8-24.1-26.1-31.6-42.4-7.2-15.9-11.2-33.3-11.6-50.7-0.4-18.4 3.7-36.1 10.3-53.2 4.1-10.7 9-21.1 13.4-31.6 3.7-8.7 7.3-17.6 5.5-27.2-0.1-1.6-2.3-0.9-2 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1005.3 955.8c2.7-11.4 7.9-22.1 13.6-32.3 5.3-9.4 11.6-18.3 21.4-23.3 1.3-0.7 0.2-2.6-1.1-1.9-9.7 4.9-16.1 13.5-21.4 22.7-6.2 10.7-11.7 22.1-14.6 34.2-0.4 1.4 1.7 2 2.1 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1015.1 959.9c4.6-21.3 16.2-40.3 33.2-54 1.1-0.9-0.5-2.5-1.6-1.6-17.2 13.9-29.1 33.3-33.7 55-0.3 1.4 1.8 2 2.1 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1071.7 922.2c-4.7 6.1-7 13.7-6.3 21.4 0.3 3.4 1.3 6.7 2.7 9.8 1.8 4 1.4 6.4 0.3 10.4-0.8 2.8-1.6 5.5-2.4 8.2-6.6 21.5-14.3 42.7-23 63.4-0.6 1.3 1.4 2.5 1.9 1.1 8.3-19.7 15.8-39.9 22.1-60.3 1.6-5.1 3.4-10.3 4.6-15.6 0.8-3.6-0.3-5.7-1.8-9-4.1-9.5-2.4-20.3 3.9-28.4 0.8-1-1.2-2.2-2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1020.9 964.1c4.6-4.6 10.3-7.6 16.7-8.8 1.4-0.3 0.8-2.4-0.6-2.2-6.8 1.2-12.8 4.5-17.7 9.4-1 1 0.6 2.6 1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1056.6 911.5c-1.6 3.4-3.3 6.7-5.2 9.9-1.8 3.1-4.8 6.1-6.2 9.3-2.1 4.6 4.7 4.5 7.9 5.3 0.4 0.1 0.8 0 1.1-0.3 5-5.8 9.8-11.7 12.1-19 0.4-1.4-1.7-2-2.2-0.6-1.3 4.2-3.4 7.9-6 11.4-0.9 1.2-3.1 4.8-4.5 5.5-1.2 0.6-4.9 0.2-6-0.7-1 0-1.1-0.2-0.4-0.5 0.6-0.9 1.3-1.7 1.9-2.6 1.2-1.7 2.4-3.5 3.5-5.4 2.2-3.6 4.2-7.4 6-11.3 0.6-1.2-1.4-2.4-2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1004.2 1011.5c6.6-2.5 17-4.8 22.4 1.2 1 1.1 2.6-0.5 1.6-1.6-6-6.6-17.2-4.5-24.6-1.7-1.4 0.4-0.8 2.6 0.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1000.9 1024c3.8-1.5 7.6-2.6 11.7-2.9 3.1-0.2 6.7 0.9 9.7 0.5 4.1-0.6 5.3-4.7 6-8.5 0.3-1.4-1.9-2-2.2-0.6-0.2 1-0.4 2-0.8 3-1 2.7-2.5 3.4-5.4 3.6-2.1 0.1-4.3-0.4-6.5-0.3-4.6 0.2-8.9 1.3-13.1 3-1.3 0.6-0.7 2.8 0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m956 847.2c4.4 2 10.8-3.9 14.1-6.3 5.4-3.9 9.9-8.6 13.4-14.3 0.7-1.2-1.2-2.4-1.9-1.1-2.8 4.8-6.5 8.8-10.8 12.2-2.2 1.7-10.6 9-13.5 7.6-1.4-0.6-2.6 1.3-1.3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m977.6 870.5c8.3-2.8 15.1-10.4 19.7-17.6 0.8-1.2-1.2-2.3-1.9-1.1-4.3 6.6-10.6 14-18.4 16.6-1.4 0.4-0.8 2.6 0.6 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m860.9 827.8c-2.1-9.1 9.3-11.9 15.6-8.7 5.4 2.8 8.8 8 10.5 13.7 1.5 5 2 10.4 2.2 15.7 0.3 7.1-5.1 12.8-12.4 10-1.3-0.5-1.9 1.6-0.6 2.2 5.6 2.2 12.7-0.5 14.7-6.4 1.5-4.3 0.3-9.9-0.3-14.3s-1.5-8.8-3.5-12.8c-3.3-6.6-10.1-12.4-17.8-11.9-6.7 0.4-12.3 6.2-10.8 13.1 0.6 1.4 2.7 0.8 2.4-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m863.6 834.5c-0.6-5.4 3.1-10.3 8.9-9.7 4.7 0.5 7.8 4.6 9.4 8.7 1.1 3 1.9 6.4 1.8 9.6-0.1 7.2-5.8 11.1-12.5 7.8-1.3-0.6-2.4 1.3-1.1 1.9 5.2 2.6 11.2 2.6 14.3-3.1 3-5.4 1.3-13.3-1.1-18.6-2.4-5.2-7.4-9.7-13.5-8.6-5.8 1.1-9.1 6.3-8.5 11.9 0.2 1.6 2.5 1.6 2.3 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m846.8 741.6c5.5-3.6 11.7-5.4 17.9-7.2 7.1-2 14.1-3.2 21.5-2.1 1.4 0.2 2-2 0.6-2.2-7.2-1-14-0.3-21 1.6s-14.1 3.9-20.2 7.9c-1.2 0.8-0.1 2.8 1.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m846 750.6c3.6-2.4 7.5-4.3 11.7-5.7 0.6-0.2 0.9-0.8 0.8-1.4-0.4-2.5-0.5-4.9 0-7.4 0.2-1.4-1.9-2-2.2-0.6-0.5 2.9-0.5 5.7 0 8.6 0.3-0.5 0.5-0.9 0.8-1.4-4.3 1.4-8.4 3.4-12.2 5.9-1.2 0.8-0.1 2.8 1.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m868 732.9c0.2 2.3-0.5 6.9 2.6 7.4 4.4 0.8 9.9-0.5 14.3-1 0.5-0.1 1-0.3 1.1-0.8 0.3-2 0.7-4.1 1-6.1 0.2-1.4-1.9-2-2.2-0.6-0.3 2-0.7 4.1-1 6.1 0.4-0.3 0.7-0.6 1.1-0.8-3 0.4-5.9 0.7-8.9 0.8-0.8 0.1-3 0.5-3.8 0.2-2.2-0.7-1.7-3.4-1.9-5.2-0.2-1.5-2.4-1.5-2.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m848.3 775.3c14.8-8.5 31.3-12.7 48.3-12.4 1.4 0 1.4-2.2 0-2.3-17.4-0.3-34.3 4-49.4 12.7-1.3 0.8-0.2 2.7 1.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m864.8 767.9c0.8 3.4 1.4 6.8 1.7 10.3 0.1 0.8 0.7 1.2 1.4 1.1 9.9-2 19.8-3.6 29.8-4.9 1.4-0.2 1.4-2.4 0-2.3-10.2 1.2-20.3 2.9-30.4 4.9 0.5 0.4 0.9 0.7 1.4 1.1-0.3-3.7-0.9-7.3-1.8-10.9-0.3-1.3-2.5-0.7-2.1 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m896 763.4c0.7 2.8 1.1 5.7 1.1 8.6 0 1.4 2.2 1.5 2.3 0 0-3.1-0.4-6.2-1.1-9.2-0.5-1.4-2.6-0.8-2.3 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m867.9 773.2c9.4-3.5 19.1-5.2 29.1-5.1 1.4 0 1.4-2.2 0-2.3-10.2-0.1-20.1 1.6-29.7 5.1-1.4 0.7-0.8 2.8 0.6 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m929.4 914.3c13.6-7.3 25.2-17.5 34.3-30 0.9-1.2-1.1-2.3-1.9-1.1-8.8 12.2-20.2 22.1-33.5 29.2-1.3 0.7-0.2 2.6 1.1 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m966.3 860.8c-4.6 9.2-10.5 17.5-17.7 24.8-1 1 0.6 2.6 1.6 1.6 7.4-7.4 13.5-15.9 18.1-25.3 0.6-1.3-1.3-2.4-2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m947 901.7c2.7 3.5 5.7 6.8 8.7 9.9 1 1 2.6-0.6 1.6-1.6-3.1-3.1-6-6.5-8.7-9.9-0.9-1.1-2.5 0.5-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m955.6 910.4c-3.2 5-7.5 9.1-12.7 11.9-1.3 0.7-0.1 2.6 1.1 1.9 5.5-3.1 10.1-7.4 13.5-12.8 0.8-1.1-1.2-2.3-1.9-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m943.9 868.4c3.1 2.8 6.2 5.6 9.2 8.4 1.1 1 2.7-0.6 1.6-1.6-3.1-2.8-6.2-5.6-9.2-8.4-1.1-0.9-2.7 0.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m944.1 867.4c2.7-2.7 5.3-5.6 7.8-8.5 0.9-1.1-0.7-2.7-1.6-1.6-2.5 3-5.1 5.8-7.8 8.5-1 1 0.6 2.6 1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m951.9 856.4c-2.7-3-5.2-6.1-7.5-9.3-0.1 0.5-0.1 0.9-0.2 1.4 2.6-2.8 5.2-5.7 7.8-8.5 1-1.1-0.6-2.7-1.6-1.6-2.6 2.8-5.2 5.7-7.8 8.5-0.3 0.3-0.5 1-0.2 1.4 2.5 3.4 5.1 6.6 7.9 9.7 1 1.1 2.6-0.5 1.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m954.4 876.4c5.1-4.8 9.1-10.5 11.9-16.9 0.6-1.3-1.4-2.5-1.9-1.1-2.7 6.2-6.6 11.7-11.5 16.4-1.1 1 0.5 2.6 1.5 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m944.1 837.8c-2.8 2.9-5.4 5.8-8 8.8-0.9 1.1 0.7 2.7 1.6 1.6 2.6-3 5.2-6 8-8.8 1-1.1-0.6-2.7-1.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m939.9 852.5c1.3 2 2.7 4 4 6.1 0.8 1.2 2.7 0.1 1.9-1.1-1.3-2-2.7-4-4-6.1-0.7-1.2-2.7-0.1-1.9 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m884.4 816c10.1 9.9 14 24.4 10.4 38.1-0.4 1.4 1.8 2 2.2 0.6 3.8-14.4-0.3-29.8-11-40.3-1.1-1-2.7 0.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m924.7 709.9c1.9 20.7-8.8 39.4-12 59.4-3 18.3 0.3 37 8.8 53.4 0.7 1.3 2.6 0.1 1.9-1.1-9.4-18.1-11.9-38.7-7.2-58.4 4.2-17.6 12.4-34.6 10.7-53.2-0.1-1.5-2.4-1.5-2.2-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m914.6 762.9c6.8 3.1 14.2 3.3 21.2 0.4 1.3-0.6 0.7-2.7-0.6-2.2-6.4 2.7-13.1 2.7-19.4-0.2-1.3-0.5-2.5 1.4-1.2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m920 748c5.9 3.4 13 3.2 18.6-0.6 1.2-0.8 0.1-2.8-1.1-1.9-5 3.4-11.1 3.6-16.3 0.6-1.3-0.8-2.4 1.2-1.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m979.6 665.8c-3.8 18.7-8.9 37-15.3 54.9-0.3 0.9 0.6 1.5 1.4 1.4 6.7-1 13.3-1.1 20-0.1 1.4 0.2 2-2 0.6-2.2-7.1-1-14.1-0.9-21.2 0.1l1.4 1.4c6.4-17.9 11.5-36.3 15.3-54.9 0.3-1.4-1.9-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m873.4 624.2c-6.5 27.2-22.1 108.1 18.2 190.6 5.6 11.5 27.4 54.1 73.4 93 26.4 22.3 52.1 36.1 70.7 44.5-3.8 2.2-7.6 4.5-11.5 6.7-4.5 21.2-7.8 36.8-9.4 44.5-5.7 26.9-8.4 40.4-4 43.8 7 5.4 25.1-4.4 36.4-15.5 10-9.9 13.7-20.1 22.2-45.8 7.6-22.8 13.7-41.9 18.2-55.9-11-6.4-25.7-15.8-41.8-29-15.7-12.9-35.7-29.3-50.5-53.2-20.9-33.7-23.8-69.5-22.9-93.6 3.6-5.7 8.5-14.4 12.8-25.6 3.8-9.9 20.9-54.2 6.1-81.5-15.1-27.8-64.7-40.3-117.9-23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m944.5 652.8c-7.6 21.1-17.5 57.6-12.8 102.7 5 48 24.1 81.2 36.7 102.7 26.2 44.7 59.1 74.1 83.5 92-0.8 11.8-2.6 25.9-6.5 41.3-5.5 21.9-13.5 39.6-20.8 52.8 1.4 0.1 3.2 0.1 5.1-0.2 6.8-1.4 10.7-6.4 12-8.2 4.2-3.9 10.1-10 15.7-18.4 7.8-11.7 11.1-22.3 17.4-43 7.2-23.6 11.9-39.3 13.8-45.6-15.2-7.7-36.6-20.3-58.7-40.3-10.5-9.5-24.3-22.1-35.8-40.3-21.5-34.4-23.5-71.5-22-95.4 8.9-12.6 25.4-40.2 23.8-76.1-0.4-8.9-1.8-16.9-3.7-23.8-15.9-0.2-31.8-0.2-47.7-0.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "hand_r",
    transform: "translate(-205.56 -198.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m840.6 376.2c-15.4-6.1-48.8 46-53.9 53.9-10.5 16.4-24.2 41.3-34.7 75.1-27.4 6.8-54.8 13.7-82.1 20.5-26.8-16.7-35.8-19.1-37.9-16.7-1.5 1.8-0.2 7.3 1.9 10.9 2.4 4.2 5.2 4.8 5.1 6.4-0.2 3.8-15.1 4.1-27 7.7-24.1 7.2-40.7 28.6-38.5 32.1 3 4.6 44.8-15.8 44.9-15.4 0.1 0.3-20.7 5.2-28.2 21.2-2.9 6.1-4.4 14.9-0.6 18 2.1 1.7 5.6 1.2 18-3.9 15.7-6.4 25.8-11.9 26.2-11.2 0.7 1.2-31.6 20.3-29.5 24.9 1.7 3.7 24.9-3.8 27.5-4.6 17.8-5.7 31.6-13.3 41.3-19.4 10.1 3.8 28.2 9 50.7 7.1 40.4-3.5 65.9-27.6 72.5-34 13.7-13.3 21.7-33.5 37.9-73.8 9.5-23.8 21.1-57.1 12.8-88.6-1.1-4.2-2.7-8.7-6.4-10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m591.4 587.9c8.4-12 23.2-16.4 36-22.3 1.7-0.8 0.2-3.4-1.5-2.6-13.3 6.2-28.2 10.8-37 23.4-1.2 1.6 1.4 3.1 2.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m638.9 542.7c5.9 7.6 14.9 11.6 24.5 11.2 1.9-0.1 1.9-3.1 0-3-8.9 0.4-16.9-3.3-22.3-10.3-1.3-1.5-3.4 0.6-2.2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m774 449.8c4 9.6 10.7 17.5 19.6 23 1.6 1 3.2-1.6 1.5-2.6-8.2-5-14.5-12.3-18.2-21.2-0.7-1.8-3.6-1-2.9 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m786.5 431c4.7 6.2 10.4 11 17.4 14.5-0.2-0.6-0.5-1.1-0.7-1.7-2.2 9.2-5.4 17.9-9.6 26.4-0.9 1.7 1.7 3.2 2.6 1.5 4.3-8.7 7.6-17.7 9.9-27.1 0.1-0.6-0.1-1.4-0.7-1.7-6.5-3.2-12-7.6-16.4-13.4-1-1.5-3.6 0-2.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m781.8 440.3c4.5 6.1 9.9 11.3 16.3 15.4 1.6 1 3.1-1.5 1.5-2.6-5.9-3.8-11.1-8.6-15.2-14.3-1.1-1.5-3.7 0-2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m781.9 561c-2.1-15.1 10.3-27.3 25.2-25.6 1.9 0.2 1.9-2.8 0-3-17.1-1.9-30.5 12.6-28.1 29.4 0.2 1.9 3.1 1.1 2.9-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m693.4 520.4c-1.7 9.9-2 19.9-0.9 29.9 0.2 1.9 3.2 1.9 3 0-1.1-9.8-0.9-19.4 0.8-29.1 0.3-1.9-2.6-2.7-2.9-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m704.7 517.3c-0.2 3.5-0.5 7.1-0.7 10.6-0.1 0.9-0.1 1.8-0.2 2.7-0.9 0.7-1.8 1.2-2.9 1.5-1.6 0.7-3.2 1.2-4.8 1.8-1.8 0.7-1 3.6 0.8 2.9 2.8-1 8.4-1.8 9.7-4.8 0.7-1.7 0.4-4.2 0.6-6 0.2-2.9 0.4-5.7 0.6-8.6 0.1-2-2.9-2-3.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m752 501.5-0.6 10.2c-0.1 1.9 2.9 1.9 3 0l0.6-10.2c0.1-1.9-2.9-1.9-3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m752.3 517.8 0.6 5.1c0.1 0.8 0.6 1.5 1.5 1.5 0.7 0 1.6-0.7 1.5-1.5l-0.6-5.1c-0.1-0.8-0.6-1.5-1.5-1.5-0.7 0-1.6 0.7-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m804.4 406.7c6.1 4.6 18.1 2.2 24.7-0.2 8.1-2.9 14.9-8.2 19.8-15.2 1.1-1.6-1.5-3.1-2.6-1.5-4.5 6.3-10.7 11.1-18 13.8-5.8 2.1-16.9 4.6-22.4 0.5-1.6-1.1-3.1 1.5-1.5 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m814 396.4c12.8 1.8 25.2-3.8 32.2-14.7 1-1.6-1.6-3.1-2.6-1.5-6.2 9.6-17.4 15-28.8 13.4-1.9-0.4-2.7 2.5-0.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m849.6 402.6c-11.3 15.2-18.8 28.3-23.6 37.3-16.8 31.9-20.3 46.8-36.7 68.4-6.1 8.1-16.4 20-32.5 32.2-12.3 2.5-29.9 6.4-50.8 11.8-25.5 6.7-38.6 10.2-53.3 16.8-12.1 5.4-29.2 14.6-47.9 30.4 9.2-0.8 20.9-2.7 34-7.1 14.7-4.9 26.2-11.3 34.4-16.8 7 2.7 17.5 5.9 30.5 7.1 33 2.8 57.7-10.2 65.8-14.6 7.5-4.1 21.2-11.7 33.1-26.9 3.6-4.5 6.9-9.7 15.4-28.7 13.5-30 21.1-47.1 26.5-72.4 1.9-8.7 4.1-21.6 5.1-37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m593.9 581.4c1.4-1.8 5.8-7.1 20.7-12.8 5.5-2.1 20.9-7.9 22.9-4.4 0.6 1.1 0.2 3.3-4.9 8.8-6.8 4.5-15.8 9.4-26.9 13.2-6 2.1-11.7 3.5-16.8 4.4 0.9-2.3 2.3-5.7 5-9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m847.6 433.5c-6.4 11.1-17.4 30.4-31.1 54.7-19.6 34.9-30.7 51.9-39.9 60.7-11.1 10.5-40 31.8-104.5 25.6 10.5 3.9 43.2 14.3 80.4 1.5 26.8-9.3 42.6-26 46.4-30.1 3.9-4.3 11.8-13.6 26.1-47.8 6.5-15.8 14.8-37.6 22.6-64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m610 598.7c11.8-3.9 26.3-9.3 42.5-16.6 11.7-5.3 19.2-9.3 19.6-8.6 0.5 0.8-11.2 9.4-24.9 15.6-14.4 6.4-27.6 8.7-37.2 9.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "backbag",
    transform: "translate(-205.56 -198.96)",
    style: {
      fill: "#808080",
      stroke: "#161616"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m923.9 378.4c5.7-1.8 88.3-26.6 140.5 21.1 56.6 51.7 27.7 143.2 14.3 185.5-14.3 45.4-33 58.1-42.8 63-18.9 9.5-37.4 6.3-55.9 3.6-31.5-4.6-76.1-9.6-133.9-11.2 6.3-79.7 12.7-159.5 19-239.2l58.8-22.8z",
    style: {
      fill: "#666666",
      stroke: "#161616"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "tube",
    transform: "translate(-205.56 -198.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m998.7 415c22.1 0.3 56.9 4.3 87.2 27 19.1 14.3 37.3 36.7 63.4 125.3 34.2 115.7 21.1 138 52.3 177.6 4.4 5.6 46.1 56.9 111 63.4 80.7 8.1 142.9-58.8 185.5-104.6 73.8-79.4 103.2-169.3 115.7-228.3 12.2 3.7 24.3 7.4 36.5 11.1-38.5 98.5-83.8 172.2-118.9 222-67.1 95.1-106.8 116.7-131.6 126.8-17.8 7.3-78.4 32-144.3 6.3-61.2-23.8-89.1-76.4-98.3-93.5-10.4-19.5-11.1-28.1-27-98.3-30.8-136.3-41.4-161.8-65-177.6-13.3-8.9-36.8-18.7-77.7-12.7 3.8-14.9 7.5-29.7 11.2-44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1066.2 470.6c1.2-10.5 7-19.7 15.8-25.4 1.6-1 0.1-3.6-1.5-2.6-9.8 6.4-16 16.4-17.3 28-0.2 2 2.8 1.9 3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1096.4 509.2c4.9-9.4 13.1-16 23.3-18.9 1.9-0.5 1.1-3.4-0.8-2.9-10.9 3-19.9 10.2-25.1 20.2-0.9 1.8 1.7 3.3 2.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1091 485.6c4.1-7.3 11.2-12.2 19.5-13.3 1.9-0.2 1.9-3.2 0-3-9.4 1.2-17.4 6.5-22.1 14.8-0.9 1.7 1.7 3.2 2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1118 581.9c6.2-8.7 16.3-13.5 26.9-13.1 1.9 0.1 1.9-2.9 0-3-11.8-0.5-22.7 5-29.5 14.6-1.2 1.6 1.4 3.1 2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1114.1 549.8c5.1-8.3 14.8-11.1 23.9-12.4 1.9-0.3 1.1-3.2-0.8-2.9-10 1.4-20.1 4.8-25.7 13.8-1 1.6 1.6 3.1 2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1103 532.7c4.9-8.2 13.5-13.2 23-13.5 1.9-0.1 1.9-3.1 0-3-10.6 0.3-20.1 5.8-25.6 14.9-1 1.7 1.6 3.2 2.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1131.5 648.6c8.4-9.1 19.9-13.8 32.3-13.3 1.9 0.1 1.9-2.9 0-3-13.1-0.5-25.5 4.6-34.4 14.2-1.4 1.4 0.8 3.5 2.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1127.4 630.4c7.6-9.3 19-14.1 31-13.1 1.9 0.2 1.9-2.8 0-3-12.7-1.1-25 4.1-33.1 14-1.3 1.4 0.8 3.6 2.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1123 610.4c5.6-6.6 13.2-10.7 21.9-11.6 1.9-0.2 1.9-3.2 0-3-9.4 1-17.8 5.2-24 12.5-1.3 1.5 0.8 3.6 2.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1131.6 594c6.2-4.3 13.2-6.1 20.7-5.3 1.9 0.2 1.9-2.8 0-3-7.9-0.8-15.6 1.1-22.2 5.7-1.6 1.2-0.1 3.8 1.5 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1162.3 754.3c5.8-10.1 15-17.4 26.1-20.8 1.8-0.6 1.1-3.5-0.8-2.9-11.9 3.6-21.7 11.4-27.9 22.2-1 1.7 1.6 3.2 2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1149.9 727.9c6.1-10.3 16.7-16.9 28.6-17.8 1.9-0.1 1.9-3.1 0-3-13 1-24.5 8.1-31.2 19.3-1 1.6 1.6 3.1 2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1142.1 694.3c7.1-9.6 18.6-14.7 30.5-13.7 1.9 0.2 1.9-2.8 0-3-13-1.1-25.4 4.7-33.1 15.2-1.2 1.6 1.4 3.1 2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1151.1 701.7c7.6-5.4 16.2-8.1 25.5-8 1.9 0 1.9-3 0-3-9.8-0.1-19 2.7-27 8.4-1.6 1.1-0.1 3.7 1.5 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1265.3 798.2c2 6.3 3 12.9 2.7 19.5-0.3 6.2-1.3 14-6.4 18.1-1.5 1.2 0.6 3.3 2.1 2.1 4.9-4.1 6.2-10.7 7-16.8 1-8.1 0-16.1-2.5-23.8-0.6-1.7-3.5-0.9-2.9 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1301.3 812.9c4.5 10.1 3.5 21.4-2.4 30.7-1 1.6 1.6 3.1 2.6 1.5 6.5-10.2 7.3-22.7 2.4-33.7-0.8-1.8-3.4-0.3-2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1364.9 805.7c8.2 10.1 10.2 23.6 5.8 35.8-0.7 1.8 2.2 2.6 2.9 0.8 4.9-13.2 2.3-27.8-6.5-38.7-1.3-1.5-3.4 0.6-2.2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1504.9 699.1c6.7 2.7 11.1 8.8 12.2 15.8 0.3 1.9 3.2 1.1 2.9-0.8-1.2-8.2-6.7-14.8-14.3-17.9-1.8-0.7-2.6 2.2-0.8 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1557.4 626.9c6.5 2.6 11.6 7.9 13.8 14.5 0.6 1.8 3.5 1 2.9-0.8-2.6-7.7-8.3-13.6-15.9-16.6-1.8-0.7-2.5 2.2-0.8 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1432.4 768.1c7.5 9.9 10.6 22 8.6 34.2-0.3 1.9 2.6 2.7 2.9 0.8 2.1-13-1-26-8.9-36.5-1.2-1.5-3.8 0-2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1403.7 791c7.6 8.8 15.7 19.5 11.4 31.7-0.6 1.8 2.3 2.6 2.9 0.8 4.6-13.3-3.9-25-12.2-34.7-1.3-1.3-3.4 0.8-2.1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1190.8 793.7c2.8-10.9 10.1-19.7 20.2-24.6 1.7-0.8 0.2-3.4-1.5-2.6-10.8 5.2-18.6 14.8-21.6 26.4-0.5 1.9 2.4 2.7 2.9 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1208.2 810.9c5.8-12 14.8-21.8 26.4-28.5 1.7-1 0.2-3.6-1.5-2.6-12 6.9-21.5 17.1-27.4 29.6-1 1.7 1.6 3.3 2.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1178.2 769.4c3.7-7 9.6-12.5 16.9-15.5 1.8-0.7 1-3.6-0.8-2.9-8.1 3.3-14.7 9.1-18.7 16.9-0.8 1.6 1.7 3.2 2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1469.8 735.5c10.3 3.4 17.9 11.9 20.3 22.5 0.4 1.9 3.3 1.1 2.9-0.8-2.6-11.6-11.1-20.9-22.3-24.6-1.9-0.6-2.7 2.3-0.9 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1488.4 727.2c4.8 2.6 8.4 6.7 10.1 11.9 0.6 1.8 3.5 1 2.9-0.8-2-5.9-6-10.7-11.5-13.7-1.7-0.9-3.2 1.7-1.5 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1523.7 676.2c5.4 1.9 9.9 5.4 13.2 10.1 1.1 1.6 3.7 0.1 2.6-1.5-3.8-5.4-8.9-9.3-15-11.5-1.8-0.6-2.6 2.3-0.8 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1582.4 572.8c8.3 1.4 15.6 5.7 20.5 12.5 1.1 1.5 3.7 0 2.6-1.5-5.4-7.4-13.2-12.4-22.3-13.9-1.9-0.3-2.7 2.6-0.8 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1342.1 816.4c4.5 8.3 5 17.6 1.5 26.4-0.7 1.8 2.2 2.6 2.9 0.8 3.7-9.5 3-19.8-1.8-28.7-0.9-1.7-3.5-0.2-2.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1465.5 758.3c5.6 5.4 8.5 12.4 8.3 20.2 0 1.9 3 1.9 3 0 0.2-8.5-3-16.4-9.2-22.3-1.4-1.4-3.5 0.8-2.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m993.2 427.7c34.8 10.1 84.8 30.9 115.9 77.4 29.6 44.2 17.7 72.5 42.8 158.1 18.3 62.4 35.7 121.5 86.7 150.4 65 36.8 144.9 2.2 159.2-4.4 39.9-18.4 64.9-46.6 103.2-90 28.5-32.2 47.1-60.5 56-74.7 22.1-35.1 51.1-90.1 70.2-164.2 7.4 2 14.8 4.1 22.1 6.1-13.7 38.4-27.8 69.3-38.9 91.6-22.9 46-43.8 76.4-85.5 137.4-16.4 23.9-28.2 40.1-45.8 58.8-16.3 17.2-30.2 32-51.9 45.8-13.7 8.7-57.1 35.4-116.8 32.1-34.1-1.9-58.8-12.8-67.2-16.8-7.2-3.4-43-21-71.7-61.8-19.6-27.8-26.3-56.4-39.7-113.7-11.6-49.4-12.6-72.4-29-123.6-11.9-37.2-19.1-49.4-29.8-59.5-28.2-26.8-67.9-27-85.5-25.9 2.2-7.8 3.9-15.5 5.7-23.1z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "torso",
    transform: "translate(-205.56 -198.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m833.1 379c-13 16.3-13.3 50.5-14.1 119-0.2 22.3 0.3 40.7 0.8 53.1-13.8 20.3-27.6 40.6-41.5 61 14.4 11.1 32.6 22.7 54.7 32.3 66.4 29 128.7 22.8 159.9 17.3 13-36.5 22.2-67.4 28.5-89.9 29.4-105.6 23.2-133.9 13.8-153-9.6-19.7-23.2-31.2-29.4-36.3-50.8-42.4-140.7-43.8-172.7-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m840.8 571.2c2.6 2.6 5.6 4.5 8.9 5.9 1.8 0.7 2.6-2.2 0.8-2.9-2.9-1.2-5.4-3-7.6-5.1-1.4-1.3-3.5 0.8-2.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m818.7 540.3c-0.2 7.9 2.1 15.4 6.8 21.8 0.8 1.2 2.8 0 1.9-1.1-4.5-6.1-6.7-13.1-6.4-20.6 0-1.5-2.2-1.5-2.3-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m937.9 530.7c33.5 10.1 70.6 3.7 98.8-17 1.2-0.8 0-2.8-1.1-1.9-27.7 20.4-64.1 26.7-97.1 16.7-1.4-0.4-2 1.8-0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m936.7 529.1c-0.6 2.8-3.1 8.7-1.5 11.5 1.7 2.8 7.8 3.2 10.6 3.7 9.8 2 19.9 2.7 29.9 2 20.4-1.3 40.1-8.1 57-19.6 1.2-0.8 0.1-2.8-1.1-1.9-14.6 10-31.3 16.4-48.8 18.6-8.5 1.1-17.1 1.2-25.6 0.4-4.7-0.5-9.4-1.3-14-2.3-3.4-0.8-5.7-0.4-5.8-5.1-0.1-2.1 0.9-4.6 1.3-6.6 0.5-1.5-1.7-2.1-2-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m795.2 588.2c17.3 21.3 40.9 36.7 67.3 44.2 1.4 0.4 2-1.8 0.6-2.2-26.1-7.3-49.2-22.6-66.3-43.6-0.9-1.1-2.5 0.5-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m788.3 598c3.5 3 6.9 6 10.4 9.1 2.6 2.3 5.6 5.9 8.7 7.5 4.7 2.5 7.8-1.8 10-5.7 0.7-1.3-1.2-2.4-1.9-1.1-1.8 3.2-3.3 6.1-7.8 4.1-2-0.9-4.2-3.7-5.9-5.2-3.9-3.5-7.9-6.9-11.8-10.4-1.2-0.8-2.8 0.8-1.7 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m828.9 618.8c-3.9 9.6 8.3 14 15.5 16.9 6.3 2.6 17.1 6.3 20.1-2.7 0.4-1.4-1.7-2-2.2-0.6-2.7 8.2-14.9 2.4-19.9 0s-14.1-6-11.3-13c0.5-1.3-1.7-1.9-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m802.9 576.8c12 12.9 26.2 23.3 42.2 30.7 1.3 0.6 2.5-1.3 1.1-1.9-15.8-7.3-29.9-17.5-41.8-30.3-0.9-1.2-2.5 0.4-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m844 444.2c-3.3 0.4-6.2-5.5-6.9-7.9-1.1-3.6-0.9-7.5 0.5-11 2.8-7.1 10.3-11.4 17.7-8.7 6.9 2.5 10.4 10.6 8.1 17.4-1.3 3.9-4.3 6.9-8 8.6-3.3 1.5-8.9 3.2-12.3 1.3-1.3-0.7-2.4 1.2-1.1 1.9 4 2.3 10.2 0.7 14.1-1.1 3.9-1.7 7-4.7 8.8-8.6 3.6-8.1-0.1-18.1-8.4-21.5-9-3.7-18.4 1.8-21.4 10.5-1.5 4.3-1.4 9.1 0.4 13.3 1.3 3.1 4.6 8.4 8.5 7.9 1.4 0 1.5-2.2 0-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m819.1 516.6c12.3 9.8 27.3 15 43.1 14.8 1.4 0 1.5-2.3 0-2.3-15.1 0.2-29.6-4.7-41.5-14.1-1.1-0.9-2.7 0.7-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m820.1 507.9c-0.2 0.8 9.5 4.4 11 5 1.6 0.7 4.2 1.2 5.6 2.3 2.7 2.2 1.2 6.9 0.6 9.8-0.3 1.4 1.9 2 2.2 0.6 0.5-2.5 2.2-8.1 1-10.5-1-2.1-5.4-3-7.3-3.8-3.9-1.6-7.8-3.6-11.8-5-1.3-0.4-2.8-0.8-3.3 0.9-0.6 1.5 1.6 2.1 2 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m875.2 586.5c27.1 9.7 55.7 14 84.4 12.8 1.4-0.1 1.5-2.3 0-2.3-28.5 1.2-56.9-3.1-83.8-12.7-1.4-0.5-2 1.7-0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m819.6 463.6c4.4 2.4 9 3.7 13.9 4.7 2.8 0.6 6.7 0.5 7.7 3.8 0.9 2.9-0.1 7.5-0.2 10.5-0.1 1.4 2.2 1.4 2.3 0 0.2-3.9 0.7-8.4 0.1-12.3-0.3-1.8-0.5-2.1-2.2-2.8-3-1.2-6.8-1.3-10-2.1-3.7-0.9-7.2-2-10.5-3.9-1.2-0.6-2.4 1.3-1.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m822.8 478.9c3.2 3.5 11 3.7 15.4 4.6 6.7 1.4 13.5 2.5 20.3 3.5 1.4 0.2 2-2 0.6-2.2-5.9-0.8-11.7-1.8-17.5-2.9-2.8-0.5-5.5-1.1-8.2-1.7-2.6-0.6-7.1-0.7-9-2.8-1-1.2-2.6 0.4-1.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m914.3 562.4c-1.1 3.9-1.6 7.9-1.8 11.9 0 1.4 2.2 1.4 2.3 0 0.1-3.8 0.7-7.6 1.7-11.3 0.3-1.4-1.8-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m915.6 563.1c15 0.7 31.5-0.3 45.8 4.9 1.4 0.5 2-1.7 0.6-2.2-14.5-5.2-31.2-4.2-46.4-4.9-1.4-0.2-1.4 2.1 0 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m914.8 576.5c14.4 1.2 28.8 2.4 43.1 3.5 1.4 0.1 1.4-2.1 0-2.3-14.4-1.2-28.8-2.4-43.1-3.5-1.4-0.1-1.4 2.2 0 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m960.2 567.2c-0.3 3.5-1.1 6.8-2.5 10.1-0.6 1.3 1.6 1.9 2.2 0.6 1.4-3.4 2.3-7 2.6-10.7 0.1-1.4-2.2-1.4-2.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m923.6 563.6c-1.2 3.8-1.7 7.6-1.8 11.5 0 1.4 2.2 1.4 2.3 0 0-3.7 0.6-7.4 1.7-10.9 0.4-1.4-1.8-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m933.7 564c-1.4 3.9-2.3 7.8-2.6 11.9-0.1 1.4 2.1 1.4 2.3 0 0.3-3.9 1.2-7.6 2.5-11.3 0.5-1.3-1.7-1.9-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m945.4 564.5c-1.2 3.7-2.3 7.4-3.5 11.1-0.4 1.4 1.7 2 2.2 0.6 1.2-3.7 2.3-7.4 3.5-11.1 0.4-1.4-1.7-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m964.3 656.1c-0.4 2.8-1.1 5.6-2.1 8.3-0.5 1.4 1.7 2 2.2 0.6 1-2.7 1.7-5.4 2.1-8.3 0.2-1.4-2-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m975.1 655.6c0 2.4-0.5 4.7-1.6 6.8-0.7 1.3 1.3 2.4 1.9 1.1 1.3-2.5 2-5.2 1.9-8 0.1-1.4-2.2-1.4-2.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m986.3 653.9c0 2-0.5 3.9-1.6 5.6-0.8 1.2 1.2 2.4 1.9 1.1 1.3-2 1.9-4.4 1.9-6.8 0.1-1.3-2.2-1.3-2.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m900.5 439.5c-1.2 9.7-2.3 19.3-3.5 29-0.2 1.9-1.2 5.1 0.1 6.8 1.7 2.2 6.2 1.9 8.6 2.3 18 2.8 36.2 4.7 54.3 5.9 1.4 0.1 1.4-2.2 0-2.3-16.1-1.1-32.1-2.7-48-5-1.9-0.3-3.8-0.6-5.8-0.9-1.6-0.2-4.5-0.1-5.8-0.9-3.2-2-1-8.7-0.6-11.8 0.9-7.7 1.8-15.4 2.8-23.2 0.4-1.4-1.9-1.4-2.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m902.2 439.4c17.4-2.9 35-0.9 52.3 1.9 3.9 0.6 10.3 0.2 11.5 4.8 0.8 3.1-0.2 7.8-0.5 11-0.8 8.4-2.7 16.7-5.3 24.8-0.4 1.4 1.7 2 2.2 0.6 3-9.1 4.9-18.5 5.6-28.1 0.2-3.2 1.3-7.9-0.1-11-1.1-2.5-3.6-2.7-6-3.1-19.9-3.5-40.1-6.4-60.2-3-1.5 0.2-0.9 2.4 0.5 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m901 451.4c21.8-3.8 44-1.8 64.8 5.8 1.4 0.5 1.9-1.7 0.6-2.2-21.2-7.7-43.8-9.7-66-5.8-1.4 0.3-0.8 2.4 0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m912.9 436.8c-0.9 3.6-1.4 7.2-1.5 11 0 1.4 2.2 1.4 2.3 0 0.1-3.5 0.5-7 1.4-10.4 0.3-1.4-1.9-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m928.7 438c-0.7 3.1-1 6.2-0.9 9.4 0 1.4 2.3 1.5 2.3 0-0.1-3 0.2-5.9 0.9-8.8 0.2-1.4-2-2-2.3-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m948.5 440c-0.6 3.4-0.9 6.8-1 10.2 0 1.4 2.2 1.4 2.3 0 0-3.2 0.3-6.4 0.9-9.6 0.2-1.4-2-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m931.9 460.9c-0.8 5.9-1.6 11.8-2.2 17.8-0.2 1.4 2.1 1.4 2.3 0 0.6-5.7 1.3-11.5 2.1-17.2 0.2-1.4-2-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m932.9 462c9.9 1.7 19.8 3.5 29.7 5.2 1.4 0.2 2-1.9 0.6-2.2-9.9-1.7-19.8-3.5-29.7-5.2-1.4-0.3-2 1.9-0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m936.9 468.5c-1.2 3.6-1.9 7.3-2.4 11-0.2 1.4 2.1 1.4 2.3 0 0.4-3.5 1.2-7 2.3-10.4 0.4-1.4-1.8-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m938 470.7c7.5 0.3 15.1 0.6 22.6 1 1.4 0.1 1.4-2.2 0-2.3-7.5-0.3-15.1-0.6-22.6-1-1.5-0.1-1.5 2.2 0 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m900 460.6c3.6 0.6 7.1 1.2 10.7 1.8-0.3-0.5-0.5-0.9-0.8-1.4-1.4 4.8-2.5 9.7-3.4 14.6-0.2 1.4 1.9 2 2.2 0.6 0.9-4.9 2-9.8 3.4-14.6 0.2-0.5-0.2-1.3-0.8-1.4-3.6-0.6-7.1-1.2-10.7-1.8-1.4-0.2-2.1 2-0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m898.8 482.3c18.9 4.9 38.3 7.2 57.8 7 1.4 0 1.5-2.3 0-2.3-19.3 0.2-38.5-2.1-57.2-6.9-1.4-0.3-2 1.9-0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m864.4 510c-1.7 11.8-3.8 23.4-6.3 35.1-0.3 1.4 1.9 2 2.2 0.6 2.5-11.6 4.6-23.3 6.3-35.1 0.2-1.4-2-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m906 616.3c-0.5 7.7-3.8 15.4-6.3 22.7-2.5 7.4-5.1 14.8-7.9 22.1-0.5 1.4 1.7 1.9 2.2 0.6 3-7.9 5.8-15.9 8.5-24 2.3-6.9 5.3-14.1 5.7-21.4 0.1-1.4-2.1-1.4-2.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m906.9 616.1c17.6 3.2 35.3 5.1 53.1 5.9l-1.1-1.1c0.6 15.4-2.4 30.5-9 44.4-0.6 1.3 1.3 2.4 1.9 1.1 6.8-14.3 9.9-29.8 9.3-45.6 0-0.6-0.5-1.1-1.1-1.1-17.6-0.8-35.1-2.7-52.5-5.8-1.4-0.2-2 2-0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m905.7 630c16.6 3.2 33.4 7.1 50.4 5.7 1.4-0.1 1.4-2.4 0-2.3-16.8 1.5-33.4-2.4-49.8-5.6-1.4-0.3-2 1.9-0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m901.8 639.6c17 6.8 35.3 9.1 53.5 6.7 1.4-0.2 1.4-2.4 0-2.3-18 2.4-36 0.1-52.9-6.6-1.3-0.5-1.9 1.6-0.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m924.3 618.7c-1.3 4.2-2.5 8.5-3.5 12.8-0.3 1.4 1.8 2 2.2 0.6 1-4.3 2.2-8.6 3.5-12.8 0.4-1.3-1.7-1.9-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m937.8 635.4-1.8 9.3c-0.3 1.4 1.9 2 2.2 0.6l1.8-9.3c0.3-1.4-1.9-2-2.2-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m906.8 657.6c-0.9-0.1-1-1.4-0.8-2 0.2-0.8 0.7-1.4 1.4-1.8 1.4-0.9 3-0.5 3.9 0.9 1.7 2.8-1.7 5.8-4.3 3.8-1.1-0.9-2.7 0.7-1.6 1.6 2.2 1.7 5.4 1.6 7.3-0.4 2-2.1 1.5-5.7-0.7-7.5-2.3-1.9-5.7-1.2-7.4 1.2s-1 6.2 2.2 6.6c1.4 0 1.4-2.2 0-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m923.8 659.2c-1.5-0.3-2.4-1.9-1.5-3.2 0.9-1.5 2.9-1.5 4.1-0.3 1 1 1.4 2.7 0 3.5-1 0.6-2.5 0.6-3.6 0.5-1.4 0-1.4 2.2 0 2.3 2.2 0.1 5.1-0.2 6.3-2.4 1.3-2.5-0.4-5.5-2.8-6.5s-5.3 0.1-6.3 2.5c-1 2.5 0.6 5.4 3.2 5.9 1.4 0.2 2-2 0.6-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m940.4 660c-3.2-0.8-1.6-5.5 1.4-4.3 1.1 0.4 1.8 1.9 1.5 3-0.4 1.4-2 2.2-3.4 1.9s-2 1.9-0.6 2.2c2.6 0.6 5.4-0.8 6.1-3.4 0.6-2.3-0.8-5.1-3.1-5.8s-5.1 0.6-5.8 3c-0.8 2.5 0.9 5.1 3.3 5.7 1.4 0.2 2-1.9 0.6-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m953.1 380c14.9 6.2 28.6 14.6 40.9 25 1.5 1.2 3.6-0.9 2.1-2.1-12.7-10.8-26.8-19.4-42.2-25.8-1.8-0.8-2.5 2.1-0.8 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m954.2 378c1.8-1.8 3.9-4 6.3-5.1 3.6-1.6 6.1-0.7 9.5 1 3.5 1.7 6.8 3.8 9.9 6.1 7.1 5.2 13.4 11.4 19.7 17.6 1.4 1.4 3.5-0.8 2.1-2.1-8-7.9-16.1-15.9-25.8-21.8-3.2-1.9-8.6-5.6-12.6-5.2-4.1 0.4-8.4 4.7-11.1 7.4-1.5 1.3 0.6 3.5 2 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m996.5 404.9c1.6-2 3.2-4.1 4.9-6 1.2-1.5-0.9-3.6-2.1-2.1-1.8 2.2-3.6 4.4-5.4 6.6-0.5 0.6-0.1 1.7 0.5 2.1 0.9 0.4 1.6 0 2.1-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m981.5 391.7c0.2-3 2.5-5.3 5.3-5.9 1.9-0.4 1.1-3.3-0.8-2.9-4.2 0.9-7.2 4.6-7.5 8.8-0.1 1.9 2.9 1.9 3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m988.4 396.6c0.6-2 2.4-3.4 4.4-3.5 1.9-0.1 1.9-3.1 0-3-3.4 0.2-6.3 2.4-7.3 5.7-0.5 1.9 2.4 2.7 2.9 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m837.2 383.7c13.5 3.8 28 7.3 43.3 10.5 18.6 3.9 36.2 6.8 52.7 8.9-15.9 89.9-21.4 123.6-23.3 136.5-0.3 2.4-2.4 17-5.5 36.6-1 6.1-1.8 11-2.2 13.9-4.6 0.3-9.3 0.7-13.9 1-11.9 19.4-23.7 38.8-35.6 58.1 13.3 5.8 30.4 11.8 50.8 15.2 37.7 6.4 69.4 1.5 89.2-3.4 3.5-9.9 8.6-25 14.7-43.5 30-91.5 32.5-116.5 33.3-128.1 2.2-31.9 3.4-51.9-7.9-74.5-22.7-45.2-85.8-59.1-88.9-59.6-57-9.4-99.4 22.7-106.7 28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "m819.7 552c-0.6 0.2 1.3 12.2 10.4 18.9 4 3 8.6 4.2 8.9 3.7 0.4-0.6-5.7-3.4-11.5-10-6-6.8-7.4-12.8-7.8-12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m875.4 586.1c5.9 5 15 11.3 27.4 15.4 27.2 9 51.1 0.8 59.2-2.3-11.9 0.7-26.9 0.5-43.8-2-17.1-2.6-31.5-6.9-42.8-11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m1032.6 442.6c-8.2 46.3-18.1 84-26.1 111-15.9 54.1-25.2 66.7-34.1 75.6-30.3 30.1-74.5 31.1-94.6 30.1 14.9 3.2 33 6 53.5 6.7 23.8 0.8 44.5-1.2 61.2-4 12.3-32.4 20.8-60.5 26.8-82.3 17.3-63.8 17.5-92.8 16.4-111-0.8-10.9-2.1-19.9-3.1-26.1z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "hand_l",
    transform: "translate(-205.56 -198.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m1013 386.4c16.2 1 26.3 33.5 32.5 53.7 7 22.6 22.9 74-1.2 126.3-14.6 31.6-38 51.4-62.4 71.9-14.4 12.1-27.4 20.8-36.8 26.7 0.5 3.8 2 19.1-8.1 33.4-12.7 18.2-33.5 20-36.3 20.2 12.4-16.3 14.3-19.8 13.8-20.2-0.7-0.6-6.7 8.3-16.7 12.1-10.4 3.9-21.2 0.7-28.3-2.3 5.4-2.3 13-6.3 20-13.7 4.1-4.3 7.5-9.2 6.7-10-1.1-1.2-8.9 8.2-19.7 8.7-6.9 0.3-12.7-3.1-16.1-5.8 4-0.6 13.5-2.6 21.9-10.4 5-4.6 7.8-9.6 9.4-12.9-2.6-0.7-5.5-1.2-8.8-1.5-7.6-0.6-13.9 0.5-18.4 1.7 9.9-12.7 19.8-18.5 27.1-21.3 12.7-5 21-2.9 33.1-10.4 7.1-4.4 11.4-9.7 16-16 24.1-33.4 41.4-57.2 43.2-88.9 1.9-32.1-14.3-33.3-13.3-65.7 1.2-37.5 24.2-76.7 42.4-75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m871.6 709.1c12.2 2.8 27.8-5.4 35.3-14.9 1.2-1.5-0.9-3.6-2.1-2.1-6.7 8.5-21.2 16.6-32.4 14.1-1.9-0.4-2.7 2.5-0.8 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m984.3 508.2c9.9-11.7 25.1-14.4 39.6-15.4 1.4-0.1 1.4-2.4 0-2.3-15.1 1.1-30.9 3.9-41.2 16.1-0.9 1.1 0.7 2.7 1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1023 493.2c1.9 8.9 2.2 17.8 1.1 26.9-0.2 1.4 2.1 1.4 2.3 0 1.1-9.2 0.7-18.4-1.2-27.5-0.3-1.4-2.5-0.8-2.2 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m984.9 533c10.9-9.1 25-10.7 38.6-12.1 1.4-0.1 1.4-2.4 0-2.3-14.3 1.4-28.8 3.3-40.2 12.8-1.1 0.9 0.5 2.5 1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m985.3 518c10.6-10.1 24.5-15.5 39.1-15.3 1.4 0 1.4-2.2 0-2.3-15.2-0.3-29.7 5.4-40.7 15.9-1 1.1 0.5 2.7 1.6 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1004.3 495.5c0.7 2.4 1.4 4.7 2.1 7.1 0.4 1.4 2.6 0.8 2.2-0.6-0.7-2.4-1.4-4.7-2.1-7.1-0.5-1.4-2.6-0.8-2.2 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m993.2 511.4c0.9 3.9 1.5 7.9 1.7 12 0.1 1.4 2.3 1.4 2.3 0-0.2-4.2-0.8-8.4-1.8-12.6-0.4-1.4-2.5-0.8-2.2 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1024.8 396.3c-7 10.6-16.9 18.7-28.8 23.4-1.3 0.5-0.8 2.7 0.6 2.2 12.4-4.9 22.7-13.3 30.1-24.4 0.8-1.3-1.1-2.4-1.9-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1003.8 419.5c1.4 1.5 3.3 4.4 5.7 3.8 1.4-0.3 2.5-1.6 3.6-2.4 1.5-1.2 3.1-2.3 4.6-3.5 1.1-0.9 0-2.8-1.1-1.9-1.8 1.4-3.6 2.7-5.4 4.1-1 0.8-1.7 1.7-3.2 1-0.9-0.4-1.9-1.9-2.6-2.6-1-1.1-2.6 0.5-1.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1038.8 428.6c0.7 1.9 1.8 3.6 3.3 5 1.1 1 2.7-0.6 1.6-1.6-1.2-1.1-2.2-2.5-2.7-4-0.5-1.3-2.6-0.7-2.2 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1051.8 537.6c-18.9 8.2-27.8 29.5-20.6 48.8 0.5 1.3 2.7 0.8 2.2-0.6-6.9-18.5 1.5-38.4 19.6-46.3 1.3-0.5 0.2-2.5-1.2-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m937.3 622.2c3.6 6.4 6.8 14.1 11.9 19.4 4.4 4.5 10.4 7 16.3 8.8 1.4 0.4 2-1.7 0.6-2.2-6.1-1.8-12.1-4.4-16.3-9.4-4.4-5.2-7.3-12-10.6-17.9-0.6-1.1-2.6 0.1-1.9 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m936.4 642.9c4.6 7.2 11.5 12.3 19.8 14.3 1.4 0.3 2-1.8 0.6-2.2-7.7-1.9-14.2-6.5-18.5-13.3-0.8-1.2-2.7-0.1-1.9 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m900 641.7c6.3 5.2 7.6 17.4 8.3 25 0.1 1.4 2.4 1.4 2.3 0-0.7-8.3-2-20.9-8.9-26.6-1.2-1-2.8 0.6-1.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m913.6 638.5c3.1 4.7 4.9 9.9 5.2 15.5 0.1 1.4 2.3 1.4 2.3 0-0.4-6-2.2-11.7-5.6-16.7-0.7-1.2-2.7 0-1.9 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m908.8 658.7c3.4-2.2 7.1-3.3 11.2-3.5 1.4-0.1 1.5-2.3 0-2.3-4.4 0.2-8.6 1.4-12.3 3.8-1.3 0.8-0.1 2.8 1.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m964.4 607.9c4.9 10.6 13 19 23.4 24.2 1.3 0.6 2.4-1.3 1.1-1.9-10.1-5.1-17.9-13.1-22.6-23.4-0.6-1.4-2.5-0.2-1.9 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m967.7 607.1c6.9-9.7 14.8-18.6 23.7-26.6 6.5-5.8 13.2-0.8 19 3.1 5.1 3.5 9.7 7.5 13.8 12 1 1.1 2.6-0.5 1.6-1.6-4.7-5-9.9-9.5-15.7-13.3-3.8-2.5-10.6-7.9-15.4-5.9-2.4 1-5 4.1-6.9 5.8-2.8 2.6-5.5 5.3-8.1 8-5.1 5.4-9.7 11.2-14 17.2-0.8 1.3 1.2 2.4 2 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m989.9 587.5c9.4 5.1 17.6 11.7 24.7 19.7 1 1.1 2.5-0.5 1.6-1.6-7.2-8.1-15.6-14.8-25.1-20-1.3-0.7-2.4 1.2-1.2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m982.3 609.9c4.1 5.2 8.7 10 13.8 14.3 1.1 0.9 2.7-0.7 1.6-1.6-5.1-4.3-9.7-9-13.8-14.3-0.9-1.2-2.5 0.4-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m984.6 609c1.2-1.7 2.6-4.3 4.4-5.5 2.9-1.9 4.2-0.1 6.4 1.4 4 2.7 7.8 5.6 11.5 8.7 1.1 0.9 2.7-0.7 1.6-1.6-2.7-2.3-5.5-4.5-8.4-6.6-2.4-1.7-5.5-4.8-8.3-5.5-4-1-7.3 5.1-9.2 7.8-0.8 1.3 1.2 2.5 2 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "m986.3 404.5c9.6 10.2 30.2 35.1 36.9 72.8 6.2 35.3-3.2 62.7-8.6 78.7-20.1 58.8-65 90.1-81.3 100.3-1.4 5.1-3.4 12.7-5.7 22.1-3.2 13-3.4 14.8-5.1 18.4-6.9 14.7-20.2 19.7-19.5 21 0.9 1.5 22.6-3.1 34.3-21 8.9-13.6 7.8-28.1 7.2-33.3 15.7-8.9 33.3-20.8 50.7-36.9 16-14.7 32.7-30.1 45.6-56.4 12.6-25.6 15.2-48.6 15.9-59.9 1.4-23.5-2.9-40.8-7.2-57.4-7.1-27.6-16.5-63.2-35.4-65.6-3.7-0.4-13.6-0.2-27.8 17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "m1047.9 551.5c-13.8 23.5-28.2 41-39.4 53.2-20.3 22-38.1 40.8-65.5 44.8-7.4 1.1-13.6 0.8-18 0.4 3.3 1.1 10 4 13.8 10.7 5.3 9.4 1.1 20-1.9 27.6-5.2 13.2-14.3 21.6-20.3 26 4.5-1.8 11.5-5.4 17.6-12.3 13.8-15.6 11.9-35.3 11.5-39.1 22.7-12.8 39.5-26.3 50.9-36.8 14.6-13.3 30.1-27.7 42.1-51.7 4.6-9 7.5-17.1 9.2-22.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "head",
    transform: "translate(-205.56 -198.96)",
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m816.2 278.6c-5.4 22.4 4.9 40.9 13.3 56.1 8.2 14.9 15 27.2 30.1 33.2 1.4 0.6 21.4 8.1 40.4-2.4 21.1-11.7 24.4-36.4 25.9-47.6 1.2-8.8 4.5-33.3-11.5-53.7-17.2-21.9-52.2-33.1-76-18.7-16.7 10.2-21.2 29.1-22.2 33.1z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m857.1 245.1c1.6 2.2 4.6 5.6 9.2 8.2 7.8 4.5 15.4 4.1 18.4 3.8 0.6 4.1 3.1 17.8 15 27.6 7.5 6.2 22.4 13.8 30.5 8.2 9.3-6.4 6-28-1.9-41.3-10.1-17.2-29.6-20.8-41-23.1-7-1.4-25.7-5.2-30.8 3.3-1.1 1.7-2.6 5.6 0.6 13.3z",
    style: {
      fill: "#ec7437",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m845.4 238.8c2.1 0.8 3.4 1.3 4.4 2.5 4.5 5.6-1.2 21.3-12.3 28.2-5.9 3.6-11.9 3.9-15.5 3.8 1 3.8 2.8 12.4-0.3 22.5-1.9 6.2-5 10.6-7.3 13.3-1.8-2.4-4-6-5.7-10.8-4.1-11.8-1.5-22.2 0-27.8 1.9-7.2 7.3-27.8 23.1-32 7.5-2 13.6 0.3 13.6 0.3z",
    style: {
      fill: "#ec7437",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m808.8 312.2c-0.6-6.7-3.9-46.2 23.4-62.6 24.4-14.7 53.4 0.9 57.6 3.1 22.8 12.6 34.5 37 35 59.1 0.1 5.3 0.6 28.9-15.7 42.8-8.3 7.1-17.4 8.7-29.5 10.9-17.9 3.2-33 1.7-42.8 0 0.6 5.8 1.2 11.7 1.8 17.5 21 4.4 38.6 4.4 50.6 3.6 17-1.1 30-4.4 38.6-6.6 15.1-3.9 27.5-8.6 36.8-12.7 2-11.4 4.1-27.8 4.2-47.6 0.1-28 0.2-46.5-9.2-66.6-3.8-8.1-17.7-37.9-51.1-49.1-37.8-12.7-70.4 8.3-76 12.1-7.7 5.2-26.4 19.6-35 45.8-1.3 3.9-7.7 24.6-1.2 50 10 39.3 43.5 61.3 45.1 60-5.6-4.7-29.7-25.5-32.6-59.7z",
    style: {
      fill: "#666666",
      strokeWidth: 2,
      stroke: "#161616"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m852.4 294.3c3.2 11.3 5.7 22.8 7.6 34.4 0.3 1.9 3.2 1.1 2.9-0.8-1.9-11.6-4.4-23.1-7.6-34.4-0.5-1.8-3.4-1-2.9 0.8z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m860.8 329.7c5.8 1.2 11.6 0.3 16.8-2.7 1.7-1 0.2-3.6-1.5-2.6-4.5 2.6-9.4 3.4-14.5 2.4-1.9-0.4-2.7 2.5-0.8 2.9z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m839.5 317.1c-3.5-3.8-4.9-8.9-3.9-14-0.8 0.2-1.7 0.4-2.5 0.7 1.9 2 3.1 4.3 3.9 6.9 0.3 0.9 0.6 1.9 0.9 2.9 0.2 0.6 0.3 1.3 0.5 1.9 0 0.9 0.4 1.4 1.4 1.6-1-1.6-3.6-0.1-2.6 1.5 0.6 1.1 1.8 1.6 3 1 1.6-0.7 1.6-2.5 1.3-4-1-5-2.8-10.1-6.3-13.9-0.7-0.8-2.3-0.4-2.5 0.7-1.2 6.2 0.4 12.2 4.7 16.9 1.3 1.4 3.4-0.8 2.1-2.2z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m833.6 305.5c0.9 4.2 2.3 8.3 4.2 12.1 0.8 1.7 3.4 0.2 2.6-1.5-1.8-3.6-3-7.4-3.9-11.4-0.4-1.9-3.3-1.1-2.9 0.8z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m881.9 298.5c-2.5-3.4-3-7.5-1.6-11.4-0.7 0.3-1.5 0.6-2.2 0.9 2.3 1.3 2.6 4.2 3.2 6.5 0.3 1.3 0.6 2.6 0.8 3.9 0.6 3.2-1-1.9-1.1-2.6-0.1-1.9-3.1-1.9-3 0 0.1 2.3 1.1 5.1 3.3 6.2 1.7 0.8 3.6 0.1 3.9-1.8 0.4-2.7-1-6.5-1.8-9.1-0.7-2.3-1.7-4.4-3.9-5.7-0.9-0.5-1.9 0-2.2 0.9-1.7 4.6-1 9.7 1.9 13.7 1.2 1.6 3.8 0.1 2.7-1.5z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m878.3 288.7c0.6 4.1 1.6 8 3.2 11.8 0.7 1.8 3.6 1 2.9-0.8-1.5-3.8-2.6-7.7-3.2-11.8-0.2-1.9-3.1-1.1-2.9 0.8z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m824.5 297.5c0.7-5 5.3-8.4 10.3-7.6 1.9 0.3 2.7-2.6 0.8-2.9-7.1-1.1-13.2 3.4-14.1 10.5-0.3 2 2.7 1.9 3 0z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m868.4 278.7c5.4-4.9 13-4.8 18.3 0.1 1.4 1.3 3.5-0.8 2.1-2.1-6.6-6.1-15.9-6.2-22.5-0.1-1.4 1.3 0.7 3.4 2.1 2.1z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m864.1 347.2c13.1 0.3 25.4-5.4 33.7-15.6 1.2-1.5-0.9-3.6-2.1-2.1-7.7 9.6-19.2 15-31.5 14.7-2.1-0.1-2.1 2.9-0.1 3z",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m892.6 329.5c2.3 0.5 4.3 2 5.1 4.2 0.7 1.8 3.6 1 2.9-0.8-1.2-3.2-3.8-5.6-7.2-6.3-1.9-0.4-2.7 2.5-0.8 2.9z",
    style: {
      strokeWidth: 2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m897.5 257.9c7.9 22.2 10.6 40.9 11.6 53.7 1.6 20.7-1.1 27.9-3.4 32.2-8.1 15.1-24.8 20.3-30.9 21.9 4.6 0.1 21.4 0.1 34.8-12 16.1-14.7 15-36.1 14.6-44.2-1.5-29.1-21.8-47.4-26.7-51.6z",
    style: {
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage);
export default __webpack_public_path__ + "static/media/home-image.430e93871eeae9cfe5e61e6fde6ea7f5.svg";
export { ForwardRef as ReactComponent };